// import React, { useState, useEffect } from 'react';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import { User } from '../core/_models'
// import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'
// interface CommitmentFormProps {
//     user?: User | any
//     isCommitmentLoading?: boolean;
//     commitment?: CommitmentData;
//     onClose?: () => void; // Add this
// }

// interface Sponsor {
//     id: string;
//     personalDetails?: {
//         name?: string;
//         email?: string;
//         mobile?: string;
//     };
//     companyDetails?: {
//         name?: string;
//         address?: string;
//     };
// }

// interface CommitmentData {
//     id?: string;
//     // clientId?: string;
//     quantity: number;
//     categoryId: string;
//     sponsorId: string;
//     sponsorName: string;
//     itemId: string;
//     completionDate: number;
//     commitmentType: string;
//     remarks?: string;
//     environment: string;
//     orderId?: string;
// }

// // interface CommitmentFormProps {
// //     isCommitmentLoading?: boolean;
// //     commitment?: CommitmentData;
// //      user?: User | any
// // }

// const CommitmentForm1: React.FC<CommitmentFormProps> = ({ user = {}, commitment = {}, isCommitmentLoading = false }) => {



//     console.log("user is this .......,", user)

//     const [loading, setLoading] = useState(false);
//     const [showToast, setShowToast] = useState(false);
//     const [toastMessage, setToastMessage] = useState('');
//     const [toastType, setToastType] = useState('success');

//     const [franchises, setFranchises] = useState<any[]>([]);
//     const [sponsors, setSponsors] = useState<Sponsor[]>([]);
//     const [categories, setCategories] = useState<any[]>([]);
//     const [items, setItems] = useState<any[]>([]);

//     const [loadingFranchises, setLoadingFranchises] = useState(false);
//     const [loadingSponsors, setLoadingSponsors] = useState(false);
//     const [loadingCategories, setLoadingCategories] = useState(false);
//     const [loadingItems, setLoadingItems] = useState(false);

//     const formatDateForInput = (timestamp: number) => {
//         if (!timestamp) return '';
//         const date = new Date(timestamp);
//         return date.toISOString().split('T')[0];
//     };

//     // Create commitmentForEdit object exactly like userForEdit in reference
//     // const [commitmentForEdit] = useState<any>({
//     //     ...user,
//     //     franchiseId: user?.clientId || '',
//     //     sponsorId: user?.sponsorId || '',
//     //     sponsorName: user?.sponsorName || '',
//     //     commitmentType: user?.commitmentType || '',
//     //     environment: user?.environment || '',
//     //     quantity: user?.quantity ? user.quantity.toString() : '',
//     //     categoryId: user?.categoryId || '',
//     //     itemId: user?.itemId || '',
//     //     completionDate: user?.completionDate ? formatDateForInput(user.completionDate) : '',
//     //     remarks: user?.remarks || ''
//     // });


//     const [commitmentForEdit] = useState<any>({
//         ...user,
//         franchiseId: user?.franchiseId || user?.clientId || '', // Use franchiseId first, then clientId as fallback
//         sponsorId: user?.sponsorId || '',
//         sponsorName: user?.sponsorName || '',
//         commitmentType: user?.commitmentType || '',
//         environment: user?.environment || '',
//         quantity: user?.quantity ? user.quantity.toString() : '',
//         categoryId: user?.categoryId || '',
//         itemId: user?.itemId || '',
//         completionDate: user?.completionDate ? formatDateForInput(user.completionDate) : '',
//         remarks: user?.remarks || ''
//     });

//     const getTokenFromStorage = () => {
//         const authData = localStorage.getItem('kt-auth-react-v');
//         if (authData) {
//             try {
//                 const parsedData = JSON.parse(authData);
//                 return parsedData.data?.token;
//             } catch (e) {
//                 console.error('Error parsing auth data:', e);
//             }
//         }
//         return null;
//     };

//     const validationSchema = Yup.object({
//         franchiseId: Yup.string().required('Supply chain is required'),
//         sponsorId: Yup.string().required('Sponsor is required'),
//         commitmentType: Yup.string().required('Commitment type is required'),
//         environment: Yup.string().required('Environment is required'),
//         quantity: Yup.number().positive('Quantity must be positive').required('Quantity is required'),
//         categoryId: Yup.string().required('Category is required'),
//         itemId: Yup.string().required('Material is required'),
//         completionDate: Yup.date().required('Completion date is required'),
//         remarks: Yup.string()
//     });

//     const formik = useFormik({
//         initialValues: commitmentForEdit,
//         validationSchema,
//         onSubmit: async (values, { setSubmitting }) => {
//             const token = getTokenFromStorage();
//             if (!token) {
//                 setToastType('error');
//                 setToastMessage('Authentication token not found. Please login again.');
//                 setShowToast(true);
//                 setTimeout(() => setShowToast(false), 3000);
//                 return;
//             }

//             setLoading(true);
//             setSubmitting(true);

//             try {
//                 const payload = {
//                     quantity: parseFloat(values.quantity),
//                     categoryId: values.categoryId,
//                     sponsorId: values.sponsorId,
//                     sponsorName: values.sponsorName,
//                     itemId: values.itemId,
//                     completionDate: new Date(values.completionDate).getTime(),
//                     // orderId: user?.orderId || `${Date.now()}_${Math.floor(Math.random() * 1000)}`,
//                     orderId: user?.orderId ? [user.orderId] : [`${Date.now()}_${Math.floor(Math.random() * 1000)}`],
//                     environment: values.environment,
//                     remarks: values.remarks,
//                     commitmentType: values.commitmentType,
//                     franchiseId: values.franchiseId
//                 };

//                 const isEdit = user?.id;
//                 const url = isEdit
//                     ? `${process.env.REACT_APP_BASE_API_URL}commitments/${user.id}/update`
//                     : `${process.env.REACT_APP_BASE_API_URL}commitment`;

//                 const method = isEdit ? 'PUT' : 'POST';

//                 const response = await fetch(url, {
//                     method: method,
//                     headers: {
//                         'token': token,
//                         'Content-Type': 'application/json',
//                         'franchiseeId': values.franchiseId
//                     },
//                     body: JSON.stringify(payload)
//                 });

//                 if (response.ok) {
//                     successToast(isEdit ? 'Commitment updated successfully!' : 'Commitment submitted successfully!')
//                     setTimeout(() => setShowToast(false), 3000);
//                     setTimeout(() => {
//                         window.location.reload();
//                     }, 1000);
//                     if (!isEdit) {
//                         formik.resetForm();
//                     }
//                 } else {
//                     const errorData = await response.json().catch(() => ({}));
//                     throw new Error(errorData.message || `Failed to ${isEdit ? 'update' : 'submit'} commitment`);
//                 }
//             } catch (error) {
//                 setToastType('error');
//                 setToastMessage((error as Error)?.message || `Failed to ${user?.id ? 'update' : 'submit'} commitment. Please try again.`);
//                 console.error('Submission error:', error);
//             } finally {
//                 setLoading(false);
//                 setSubmitting(false);
//                 setShowToast(true);
//                 setTimeout(() => setShowToast(false), 3000);
//             }
//         }
//     });

//     // Fetch functions
//     const fetchFranchises = async () => {
//         const token = getTokenFromStorage();
//         if (!token) return;

//         setLoadingFranchises(true);
//         try {
//             const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=FRANCHISE`, {
//                 headers: { 'token': token }
//             });
//             const data = await response.json();
//             setFranchises(data.content || data || []);
//         } catch (error) {
//             console.error('Failed to fetch franchises:', error);
//         } finally {
//             setLoadingFranchises(false);
//         }
//     };

//     const fetchSponsors = async () => {
//         const token = getTokenFromStorage();
//         if (!token) return;

//         setLoadingSponsors(true);
//         try {
//             const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=SPONSOR`, {
//                 headers: { 'token': token }
//             });
//             const data = await response.json();
//             setSponsors(data.content || data || []);
//         } catch (error) {
//             console.error('Failed to fetch sponsors:', error);
//         } finally {
//             setLoadingSponsors(false);
//         }
//     };

//     // const fetchCategories = async (franchiseId: string) => {
//     //     const token = getTokenFromStorage();
//     //     if (!token || !franchiseId) return;

//     //     setLoadingCategories(true);
//     //     try {
//     //         const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}clients/101212/categories?page=0&size=10`, {
//     //             headers: {
//     //                 'token': token,
//     //                 'franchiseeId': franchiseId
//     //             }
//     //         });
//     //         const data = await response.json();
//     //         setCategories(data.data || []);
//     //     } catch (error) {
//     //         console.error('Failed to fetch categories:', error);
//     //     } finally {
//     //         setLoadingCategories(false);
//     //     }
//     // };



//     const fetchCategories = async (franchiseId: string) => {
//         const token = getTokenFromStorage();
//         if (!token || !franchiseId) return;

//         setLoadingCategories(true);
//         try {
//             // Use the actual franchiseId instead of hardcoded 101212
//             const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}clients/${franchiseId}/categories?page=0&size=10`, {
//                 headers: {
//                     'token': token,
//                     'franchiseeId': franchiseId
//                 }
//             });
//             const data = await response.json();
//             setCategories(data.data || []);
//         } catch (error) {
//             console.error('Failed to fetch categories:', error);
//         } finally {
//             setLoadingCategories(false);
//         }
//     };


//     const fetchItems = async (categoryId: string, franchiseId: string) => {
//         const token = getTokenFromStorage();
//         if (!token || !categoryId || !franchiseId) return;

//         setLoadingItems(true);
//         try {
//             const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}categories/${categoryId}/items?page=0&size=10`, {
//                 headers: {
//                     'token': token,
//                     'franchiseeId': franchiseId
//                 }
//             });
//             const data = await response.json();
//             setItems(data.data || []);
//         } catch (error) {
//             console.error('Failed to fetch items:', error);
//         } finally {
//             setLoadingItems(false);
//         }
//     };

//     // Initial data loading - separate useEffects like in reference
//     useEffect(() => {
//         fetchFranchises();
//     }, []);

//     useEffect(() => {
//         fetchSponsors();
//     }, []);

//     // Load categories when franchiseId is available (for edit mode)
//     useEffect(() => {
//         if (commitmentForEdit.franchiseId) {
//             fetchCategories(commitmentForEdit.franchiseId);
//         }
//     }, [commitmentForEdit.franchiseId]);


//     // Sync sponsor name with live data when sponsors are loaded (for edit mode)


//     // Load items when both categoryId and franchiseId are available (for edit mode)
//     useEffect(() => {
//         if (commitmentForEdit.categoryId && commitmentForEdit.franchiseId) {
//             fetchItems(commitmentForEdit.categoryId, commitmentForEdit.franchiseId);
//         }
//     }, [commitmentForEdit.categoryId, commitmentForEdit.franchiseId]);

//     // Handle franchise change
//     const handleFranchiseChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
//         const franchiseId = e.target.value;
//         formik.setFieldValue('franchiseId', franchiseId);

//         // Only clear if not the same value (prevent clearing on edit load)
//         if (franchiseId !== commitmentForEdit.franchiseId) {
//             formik.setFieldValue('categoryId', '');
//             formik.setFieldValue('itemId', '');
//             setCategories([]);
//             setItems([]);
//         }

//         if (franchiseId) {
//             await fetchCategories(franchiseId);
//         }
//     };

//     // Handle category change
//     const handleCategoryChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
//         const categoryId = e.target.value;
//         formik.setFieldValue('categoryId', categoryId);

//         // Only clear if not the same value (prevent clearing on edit load)
//         if (categoryId !== commitmentForEdit.categoryId) {
//             formik.setFieldValue('itemId', '');
//             setItems([]);
//         }

//         if (categoryId && formik.values.franchiseId) {
//             await fetchItems(categoryId, formik.values.franchiseId);
//         }
//     };

//     const isEdit = !!user?.id;




//     useEffect(() => {
//         if (sponsors.length > 0 && formik.values.sponsorId && isEdit) {
//             const selectedSponsor = sponsors.find(s => s.id === formik.values.sponsorId);
//             if (selectedSponsor) {
//                 const liveSponsorName = selectedSponsor.companyDetails?.name || selectedSponsor.personalDetails?.name || '';
//                 // Only update if the name is different to avoid unnecessary re-renders
//                 if (liveSponsorName !== formik.values.sponsorName) {
//                     formik.setFieldValue('sponsorName', liveSponsorName);
//                 }
//             }
//         }
//     }, [sponsors, formik.values.sponsorId, isEdit]);

//     return (
//         <div className="">
//             {/* <h2 className="text-2xl font-bold mb-6 text-gray-800">
//                 {isEdit ? 'Edit Commitment' : 'Create Commitment'}
//             </h2> */}

//             {/* Toast Notification */}
//             {showToast && (
//                 <div className={`fixed top-4 right-4 p-4 rounded-md shadow-lg z-50 ${toastType === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`}>
//                     {toastMessage}
//                 </div>
//             )}

//             <form onSubmit={formik.handleSubmit} noValidate>
//                 <div className="space-y-4">
//                     {/* Row 1: Supply chain & Sponsor */}
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Select Supply chain</label>
//                             <select
//                                 {...formik.getFieldProps('franchiseId')}
//                                 onChange={handleFranchiseChange}
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 disabled={loadingFranchises || formik.isSubmitting || isCommitmentLoading}
//                             >
//                                 <option value="">{loadingFranchises ? 'Loading...' : 'Select Supply chain'}</option>
//                                 {franchises.map((franchise) => (
//                                     <option key={franchise.id} value={franchise.id}>
//                                         {franchise.companyDetails?.name || franchise.personalDetails?.name || 'Unknown Supply chain'}
//                                     </option>
//                                 ))}
//                             </select>
//                             {formik.touched.franchiseId && formik.errors.franchiseId && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         {/* <span role="alert">{formik.errors.franchiseId}</span> */}
//                                     </div>
//                                 </div>
//                             )}
//                         </div>

//                         {/* <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Select Sponsor</label>
//                             <select
//                                 {...formik.getFieldProps('sponsorId')}
//                                 onChange={(e) => {
//                                     formik.handleChange(e);
//                                     const selectedSponsor = sponsors.find((s: Sponsor) => s.id === e.target.value);
//                                     formik.setFieldValue('sponsorName', selectedSponsor?.companyDetails?.name || selectedSponsor?.personalDetails?.name || '');
//                                 }}
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 disabled={loadingSponsors || formik.isSubmitting || isCommitmentLoading}
//                             >
//                                 <option value="">{loadingSponsors ? 'Loading...' : 'Select Sponsor'}</option>
//                                 {sponsors.map((sponsor: Sponsor) => (
//                                     <option key={sponsor.id} value={sponsor.id}>
//                                         {sponsor.companyDetails?.name || sponsor.personalDetails?.name || 'Unknown Sponsor'}
//                                     </option>
//                                 ))}
//                             </select>
//                             {formik.touched.sponsorId && formik.errors.sponsorId && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">

//                                     </div>
//                                 </div>
//                             )}
//                         </div> */}

//                         <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Select Sponsor</label>
//                             <div className="position-relative">
//                                 <select
//                                     {...formik.getFieldProps('sponsorId')}
//                                     onChange={(e) => {
//                                         formik.handleChange(e);
//                                         const selectedSponsor = sponsors.find((s: Sponsor) => s.id === e.target.value);
//                                         formik.setFieldValue('sponsorName', selectedSponsor?.companyDetails?.name || selectedSponsor?.personalDetails?.name || '');
//                                     }}
//                                     style={{
//                                         backgroundColor: '#ffffff',
//                                         border: '1px solid #dddddd',
//                                         color: '#000000',
//                                         paddingLeft: (formik.values.sponsorId && user?.sponsorLogo) ? '45px' : '12px'
//                                     }}
//                                     className="form-control form-control-solid mb-3 mb-lg-0"
//                                     disabled={loadingSponsors || formik.isSubmitting || isCommitmentLoading}
//                                 >
//                                     <option value="">{loadingSponsors ? 'Loading...' : 'Select Sponsor'}</option>
//                                     {sponsors.map((sponsor: Sponsor) => (
//                                         <option key={sponsor.id} value={sponsor.id}>
//                                             {sponsor.companyDetails?.name || sponsor.personalDetails?.name || 'Unknown Sponsor'}
//                                         </option>
//                                     ))}
//                                 </select>
//                                 {formik.values.sponsorId && user?.sponsorLogo && (
//                                     <img
//                                         src={user.sponsorLogo}
//                                         alt="sponsor logo"
//                                         className="position-absolute rounded-circle"
//                                         style={{
//                                             width: '20px',
//                                             height: '20px',
//                                             left: '12px',
//                                             top: '50%',
//                                             transform: 'translateY(-50%)',
//                                             objectFit: 'cover',
//                                             pointerEvents: 'none'
//                                         }}
//                                         onError={(e) => {
//                                             e.currentTarget.style.display = 'none';
//                                         }}
//                                     />
//                                 )}
//                             </div>
//                             {formik.touched.sponsorId && formik.errors.sponsorId && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         {/* <span role="alert">{formik.errors.sponsorId}</span> */}
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     {/* Row 2: Commitment Type & Environment */}
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Commitment Type</label>
//                             <select
//                                 {...formik.getFieldProps('commitmentType')}
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 disabled={formik.isSubmitting || isCommitmentLoading}
//                             >
//                                 <option value="">Select type</option>
//                                 {/* <option value="RECYCLE">Recycling</option> */}
//                                 <option value="COLLECT">Collection</option>
//                                 <option value="PLASTIC_PREVENTED">Plastic Prevented</option>
//                                 <option value="HOUSEHOLDS_BENEFITED">Households Benefited</option>
//                                 <option value="CLEANUPS_CONDUCTED">Cleanups Conducted</option>
//                                 <option value="TREES_PLANTED">Trees Planted</option>
//                             </select>
//                             {formik.touched.commitmentType && formik.errors.commitmentType && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         {/* <span role="alert">{formik.errors.commitmentType}</span> */}
//                                     </div>
//                                 </div>
//                             )}
//                         </div>

//                         <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Environment</label>
//                             <select
//                                 {...formik.getFieldProps('environment')}
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 disabled={formik.isSubmitting || isCommitmentLoading}
//                             >
//                                 <option value="">Select Environment</option>
//                                 <option value="RIVER">River & Ocean</option>
//                                 <option value="COMMUNITIES">Communities</option>
//                                 <option value="ANY">Any</option>
//                             </select>
//                             {formik.touched.environment && formik.errors.environment && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         {/* <span role="alert">{formik.errors.environment}</span> */}
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     {/* Row 3: Category & Material */}
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Select category</label>
//                             <select
//                                 {...formik.getFieldProps('categoryId')}
//                                 onChange={handleCategoryChange}
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 disabled={loadingCategories || !formik.values.franchiseId || formik.isSubmitting || isCommitmentLoading}
//                             >
//                                 <option value="">
//                                     {loadingCategories ? 'Loading...' : !formik.values.franchiseId ? 'Select supply chain first' : 'Select category'}
//                                 </option>
//                                 {categories.map((category) => (
//                                     <option key={category.id} value={category.id}>
//                                         {category.displayName || category.name}
//                                     </option>
//                                 ))}
//                             </select>
//                             {formik.touched.categoryId && formik.errors.categoryId && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         {/* <span role="alert">{formik.errors.categoryId}</span> */}
//                                     </div>
//                                 </div>
//                             )}
//                         </div>

//                         <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Any specific material</label>
//                             <select
//                                 {...formik.getFieldProps('itemId')}
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 disabled={loadingItems || !formik.values.categoryId || formik.isSubmitting || isCommitmentLoading}
//                             >
//                                 <option value="">
//                                     {loadingItems ? 'Loading...' : !formik.values.categoryId ? 'Select category first' : 'Select Items'}
//                                 </option>
//                                 {items.map((item) => (
//                                     <option key={item.id} value={item.id}>
//                                         {item.displayName || item.name}
//                                     </option>
//                                 ))}
//                             </select>
//                             {formik.touched.itemId && formik.errors.itemId && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         {/* <span role="alert">{formik.errors.itemId}</span> */}
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     {/* Row 4: Quantity & Completion Date */}
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Quantity</label>
//                             <input
//                                 type="number"
//                                 placeholder="Enter quantity in kg"
//                                 step="0.1"
//                                 {...formik.getFieldProps('quantity')}
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 autoComplete="off"
//                                 disabled={formik.isSubmitting || isCommitmentLoading}
//                             />
//                             {formik.touched.quantity && formik.errors.quantity && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         {/* <span role="alert">{formik.errors.quantity}</span> */}
//                                     </div>
//                                 </div>
//                             )}
//                         </div>

//                         <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Completion Date</label>
//                             <input
//                                 type="date"
//                                 {...formik.getFieldProps('completionDate')}
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 autoComplete="off"
//                                 disabled={formik.isSubmitting || isCommitmentLoading}
//                             />
//                             {formik.touched.completionDate && formik.errors.completionDate && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         {/* <span role="alert">{formik.errors.completionDate}</span> */}
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     {/* Row 5: Remarks (Full Width) */}
//                     <div className="fv-row mb-7">
//                         <label className="fw-bold fs-6 mb-2">Remarks</label>
//                         <textarea
//                             placeholder="Free text"
//                             rows={3}
//                             {...formik.getFieldProps('remarks')}
//                             style={{
//                                 backgroundColor: '#ffffff',
//                                 border: '1px solid #dddddd',
//                                 color: '#000000',
//                             }}
//                             className="form-control form-control-solid mb-3 mb-lg-0"
//                             disabled={formik.isSubmitting || isCommitmentLoading}
//                         />
//                         {formik.touched.remarks && formik.errors.remarks && (
//                             <div className="fv-plugins-message-container">
//                                 <div className="fv-help-block">
//                                     {/* <span role="alert">{formik.errors.remarks}</span> */}
//                                 </div>
//                             </div>
//                         )}
//                     </div>

//                     {/* Submit Button */}
//                     <div className="text-center pt-15">
//                         <button
//                             type="submit"
//                             style={{ backgroundColor: '#000000' }}
//                             className="btn btn-primary"
//                             disabled={isCommitmentLoading || formik.isSubmitting || !formik.isValid}
//                         >
//                             <span className="indicator-label">
//                                 {isEdit ? 'Update' : 'Submit'}
//                             </span>
//                             {(formik.isSubmitting || isCommitmentLoading) && (
//                                 <span className="indicator-progress">
//                                     Please wait...{' '}
//                                     <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
//                                 </span>
//                             )}
//                         </button>
//                     </div>
//                 </div>
//             </form>
//         </div>
//     );
// };

// export default CommitmentForm1;



















// import React, { useState, useEffect } from 'react';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import { User } from '../core/_models'
// import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'
// import { useNavigate } from 'react-router-dom'
// import CountryDropDown from '../../../../../../_metronic/helpers/countryDropDown';
// import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery';  
// import { useLocation } from 'react-router-dom';


// interface CommitmentFormProps {
//     user?: User | any
//     isCommitmentLoading?: boolean;
//     commitment?: CommitmentData;
//     onClose?: () => void;
// }

// interface Sponsor {
//     id: string;
//     personalDetails?: {
//         name?: string;
//         email?: string;
//         mobile?: string;
//     };
//     companyDetails?: {
//         name?: string;
//         address?: string;
//     };
// }

// interface CommitmentData {
//     id?: string;
//     quantity: number;
//     categoryId: string;
//     sponsorId: string;
//     sponsorName: string;
//     itemId: string;
//     startDate: number;
//     endDate: number;
//     commitmentType: string;
//     subType: string;
//     remarks?: string;
//     orderId?: string;
//     householdTarget?: number;
//     projectTarget?: number;
//     sponsorshipValue?: number;
// }

// const CommitmentForm1: React.FC<CommitmentFormProps> = ({ user = {}, commitment = {}, isCommitmentLoading = false }) => {

//     // console.log("user is this .......,", user)
//     const navigate = useNavigate()

//     const [loading, setLoading] = useState(false);
//     const [showToast, setShowToast] = useState(false);
//     const [toastMessage, setToastMessage] = useState('');
//     const [toastType, setToastType] = useState('success');

//     const [franchises, setFranchises] = useState<any[]>([]);
//     const [sponsors, setSponsors] = useState<Sponsor[]>([]);

//     const [loadingFranchises, setLoadingFranchises] = useState(false);
//     const [loadingSponsors, setLoadingSponsors] = useState(false);
//   const { pathname } = useLocation();

//     const isEdit = !!user?.id;



//     const { responseData: sponsorshipPackages } = useFetchCommon({
//         api: `sponsorship-packages?page=0&size=10`,
//         label: ['packageName'],
//         isDropDown: true,
//     })

//     const formatDateForInput = (dateValue: number | string) => {
//         if (!dateValue) return '';
//         const date = new Date(dateValue);
//         if (isNaN(date.getTime())) return ''; 
//         return date.toISOString().split('T')[0];
//     };

//     const [commitmentForEdit] = useState<any>({
//         ...user,
//         franchiseId: user?.franchiseId || user?.clientId || '',
//         sponsorId: user?.sponsorId || '',
//         sponsorName: user?.sponsorName || '',
//         // commitmentType: user?.commitmentType || '',
//         commitmentType: user?.packageId || '',
//         packageName: user?.packageInfo?.packageName || '',
//         subType: user?.subType || '',
//         quantity: user?.quantity ? user.quantity.toString() : '',
//         householdTarget: user?.householdTarget ? user.householdTarget.toString() : '',
//         projectTarget: user?.projectTarget ? user.projectTarget.toString() : '',
//         startDate: user?.startDate ? formatDateForInput(user.startDate) : '',
//         endDate: user?.endDate ? formatDateForInput(user.endDate) : '',
//         remarks: user?.remarks || '',
//          sponsorshipValue: user?.sponsorshipValue ? user.sponsorshipValue.toString() : '',
//             country: user?.country || '' // Add this
//     });


//     const getTokenFromStorage = () => {
//         const authData = localStorage.getItem('kt-auth-react-v');
//         if (authData) {
//             try {
//                 const parsedData = JSON.parse(authData);
//                 return parsedData.data?.token;
//             } catch (e) {
//                 console.error('Error parsing auth data:', e);
//             }
//         }
//         return null;
//     };

//     // const validationSchema = Yup.object({
//     //     // country: Yup.string().required('Country is required'),
//     //     franchiseId: Yup.string().required('Supply chain is required'),
//     //     sponsorId: Yup.string().required('Sponsor is required'),
//     //     commitmentType: Yup.string().required('Package type is required'),
//     //     subType: Yup.string().required('Sub type is required'),
//     //     quantity: Yup.number().positive('Quantity must be positive').required('Quantity is required'),
//     //     householdTarget: Yup.number().positive('Target must be positive'),
//     //     projectTarget: Yup.number().positive('Target must be positive'),
//     //     startDate: Yup.date().required('Start date is required'),
//     //     endDate: Yup.date().required('End date is required'),
//     //     sponsorshipValue: Yup.number().positive('Sponsorship value must be positive').required('Sponsorship value is required')
//     // });


//     const validationSchema = Yup.object({
//         franchiseId: Yup.string().required('Supply chain is required'),
//         sponsorId: Yup.string().required('Sponsor is required'),
//         commitmentType: Yup.string().required('Package type is required'),
//         startDate: Yup.date().required('Start date is required'),
//         endDate: Yup.date().required('End date is required'),
//     });

//     const formik = useFormik({
//         initialValues: commitmentForEdit,
//         validationSchema,
//         onSubmit: async (values, { setSubmitting }) => {
//             const token = getTokenFromStorage();
//             if (!token) {
//                 setToastType('error');
//                 setToastMessage('Authentication token not found. Please login again.');
//                 setShowToast(true);
//                 setTimeout(() => setShowToast(false), 3000);
//                 return;
//             }

//             setLoading(true);
//             setSubmitting(true);

//             try {
//                 const payload: any = {
//                     // sponsorshipValue: parseFloat(values.sponsorshipValue),
//                     // quantity: parseFloat(values.quantity),
//                     sponsorId: values.sponsorId,
//                     sponsorName: values.sponsorName,
//                     startDate: new Date(values.startDate).getTime(),
//                     endDate: new Date(values.endDate).getTime(),
//                     orderId: user?.orderId ? [user.orderId] : [`${Date.now()}_${Math.floor(Math.random() * 1000)}`],
//                     // remarks: values.remarks,
//                     commitmentType: values.commitmentType,
//                     // subType: values.subType,
//                     franchiseId: values.franchiseId,
//                     packageId: values.commitmentType
//                 };

//                 if (values.householdTarget) {
//                     payload.householdTarget = parseFloat(values.householdTarget);
//                 }
//                 if (values.projectTarget) {
//                     payload.projectTarget = parseFloat(values.projectTarget);
//                 }

//                 const isEdit = user?.id;
//                 const url = isEdit
//                     ? `${process.env.REACT_APP_BASE_API_URL}sponsorCommitments/${user.id}`
//                     : `${process.env.REACT_APP_BASE_API_URL}sponsorCommitments`;

//                 const method = isEdit ? 'PUT' : 'POST';

//                 const response = await fetch(url, {
//                     method: method,
//                     headers: {
//                         'token': token,
//                         'Content-Type': 'application/json',
//                         'franchiseeId': values.franchiseId
//                     },
//                     body: JSON.stringify(payload)
//                 });

//                 if (response.ok) {
//                     successToast(isEdit ? 'Commitment updated successfully!' : 'Commitment submitted successfully!')
//                     setTimeout(() => {
//                         // navigate('/apps/makting/commitment');
//                         window.location.reload();
//                     }, 1000);
//                     if (!isEdit) {
//                         formik.resetForm();
//                     }
//                 } else {
//                     const errorData = await response.json().catch(() => ({}));
//                     throw new Error(errorData.message || `Failed to ${isEdit ? 'update' : 'submit'} commitment`);
//                 }
//             } catch (error) {
//                 setToastType('error');
//                 setToastMessage((error as Error)?.message || `Failed to ${user?.id ? 'update' : 'submit'} commitment. Please try again.`);
//                 console.error('Submission error:', error);
//             } finally {
//                 setLoading(false);
//                 setSubmitting(false);
//                 setShowToast(true);
//                 setTimeout(() => setShowToast(false), 3000);
//             }
//         }
//     });

//     // Fetch functions
//     const fetchFranchises = async () => {
//         const token = getTokenFromStorage();
//         if (!token) return;

//         setLoadingFranchises(true);
//         try {
//             const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=FRANCHISE`, {
//                 headers: { 'token': token }
//             });
//             const data = await response.json();
//             setFranchises(data.content || data || []);
//         } catch (error) {
//             console.error('Failed to fetch franchises:', error);
//         } finally {
//             setLoadingFranchises(false);
//         }
//     };

//     const fetchSponsors = async () => {
//         const token = getTokenFromStorage();
//         if (!token) return;

//         setLoadingSponsors(true);
//         try {
//             const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=SPONSOR`, {
//                 headers: { 'token': token }
//             });
//             const data = await response.json();
//             setSponsors(data.content || data || []);
//         } catch (error) {
//             console.error('Failed to fetch sponsors:', error);
//         } finally {
//             setLoadingSponsors(false);
//         }
//     };

//     // Initial data loading
//     useEffect(() => {
//         fetchFranchises();
//     }, []);

//     useEffect(() => {
//         fetchSponsors();
//     }, []);

//     useEffect(() => {
//         if (sponsors.length > 0 && formik.values.sponsorId && isEdit) {
//             const selectedSponsor = sponsors.find(s => s.id === formik.values.sponsorId);
//             if (selectedSponsor) {
//                 const liveSponsorName = selectedSponsor.companyDetails?.name || selectedSponsor.personalDetails?.name || '';
//                 if (liveSponsorName !== formik.values.sponsorName) {
//                     formik.setFieldValue('sponsorName', liveSponsorName);
//                 }
//             }
//         }
//     }, [sponsors, formik.values.sponsorId, isEdit]);

//     // Get sub type options based on commitment type
//     const getSubTypeOptions = () => {
//         switch (formik.values.commitmentType) {
//             case 'VOLUME_LINKED':
//                 return [
//                     { value: 'COLLECTION', label: 'Collection' },
//                     { value: 'RECYCLING', label: 'Recycling' }
//                 ];
//             case 'USER_TYPE_LINKED':
//                 return [
//                     { value: 'HOUSEHOLD', label: 'New Household' },
//                     { value: 'SOCIAL_BENEFIT', label: 'Social Benefit' }
//                 ];
//             case 'GENERAL':
//                 return [
//                     { value: 'GENERAL', label: 'General' }
//                 ];
//             default:
//                 return [];
//         }
//     };

//     // Get quantity placeholder based on commitment type
//     const getQuantityPlaceholder = () => {
//         switch (formik.values.commitmentType) {
//             case 'COLLECT':
//                 return 'Enter Plastic prevention in kg';
//             case 'HOUSEHOLDS_BENEFITED':
//                 return 'Enter household Target No.';
//             case 'CLEANUPS_CONDUCTED':
//                 return 'Enter project Target';
//             default:
//                 return 'Enter quantity';
//         }
//     };

//     // Handle commitment type change
//     const handleCommitmentTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//         const commitmentType = e.target.value;
//         formik.setFieldValue('commitmentType', commitmentType);
//         formik.setFieldValue('subType', ''); // Reset sub type when commitment type changes
//     };

//     return (

// <div className={pathname.includes('/apps/commitment/new') ? 'card' : ''} style={pathname.includes('/apps/commitment/new') ? {padding:"20px"} : {}}>
//         <div className="">
//             {/* Toast Notification */}
//             {showToast && (
//                 <div className={`fixed top-4 right-4 p-4 rounded-md shadow-lg z-50 ${toastType === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`}>
//                     {toastMessage}
//                 </div>
//             )}

//             <form onSubmit={formik.handleSubmit} noValidate>
//                 <div className="space-y-4">
//                     {/* Row 1: Supply chain & Sponsor */}
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                         <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Select Country</label>
//                             <select
//                                 {...formik.getFieldProps('franchiseId')}
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 disabled={loadingFranchises || formik.isSubmitting || isCommitmentLoading}
//                             >
//                                 <option value="">{loadingFranchises ? 'Loading...' : 'Select Country'}</option>
//                                 {franchises.map((franchise) => (
//                                     <option key={franchise.id} value={franchise.id}>
//                                         {franchise.companyDetails?.name || franchise.personalDetails?.name || 'Unknown Supply chain'}
//                                     </option>
//                                 ))}
//                             </select>
//                             {formik.touched.franchiseId && formik.errors.franchiseId && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         <span role="alert">{formik.errors.franchiseId as string}</span>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>

//                         <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Select Sponsor</label>
//                             <div className="position-relative">
//                                 <select
//                                     {...formik.getFieldProps('sponsorId')}
//                                     onChange={(e) => {
//                                         formik.handleChange(e);
//                                         const selectedSponsor = sponsors.find((s: Sponsor) => s.id === e.target.value);
//                                         formik.setFieldValue('sponsorName', selectedSponsor?.companyDetails?.name || selectedSponsor?.personalDetails?.name || '');
//                                     }}
//                                     style={{
//                                         backgroundColor: '#ffffff',
//                                         border: '1px solid #dddddd',
//                                         color: '#000000',
//                                         paddingLeft: (formik.values.sponsorId && user?.sponsorLogo) ? '45px' : '12px'
//                                     }}
//                                     className="form-control form-control-solid mb-3 mb-lg-0"
//                                     disabled={loadingSponsors || formik.isSubmitting || isCommitmentLoading}
//                                 >
//                                     <option value="">{loadingSponsors ? 'Loading...' : 'Select Sponsor'}</option>
//                                     {sponsors.map((sponsor: Sponsor) => (
//                                         <option key={sponsor.id} value={sponsor.id}>
//                                             {sponsor.companyDetails?.name || sponsor.personalDetails?.name || 'Unknown Sponsor'}
//                                         </option>
//                                     ))}
//                                 </select>
//                                 {formik.values.sponsorId && user?.sponsorLogo && (
//                                     <img
//                                         src={user.sponsorLogo}
//                                         alt="sponsor logo"
//                                         className="position-absolute rounded-circle"
//                                         style={{
//                                             width: '20px',
//                                             height: '20px',
//                                             left: '12px',
//                                             top: '50%',
//                                             transform: 'translateY(-50%)',
//                                             objectFit: 'cover',
//                                             pointerEvents: 'none'
//                                         }}
//                                         onError={(e) => {
//                                             e.currentTarget.style.display = 'none';
//                                         }}
//                                     />
//                                 )}
//                             </div>
//                             {formik.touched.sponsorId && formik.errors.sponsorId && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         <span role="alert">{formik.errors.sponsorId as string}</span>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     {/* Row 2: Commitment Type & Sub Type */}
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">




//                         <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Select Package</label>
//                             {/* <select
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: formik.values.commitmentType ? '#000000' : '#9da4ba'
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 {...formik.getFieldProps('commitmentType')}
//                                 onChange={handleCommitmentTypeChange}
//                                 disabled={formik.isSubmitting || isCommitmentLoading}
//                             >
//                                 <option value="" style={{ color: '#9da4ba' }}>Select Package...</option>
//                                 {sponsorshipPackages?.map((pkg: any) => (
//                                     <option key={pkg.value} value={pkg.value} style={{ color: '#000000' }}>
//                                         {pkg.label || 'Package'}
//                                     </option>
//                                 ))}
//                             </select> */}
//                             <select
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: formik.values.commitmentType ? '#000000' : '#9da4ba'
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 {...formik.getFieldProps('commitmentType')}
//                                 onChange={handleCommitmentTypeChange}
//                                 disabled={formik.isSubmitting || isCommitmentLoading}
//                             >
//                                 <option value="" style={{ color: '#9da4ba' }}>Select Package...</option>
//                                 {sponsorshipPackages?.map((pkg: any) => (
//                                     <option key={pkg.value} value={pkg.value} style={{ color: '#000000' }}>
//                                         {pkg.label || pkg.packageName || 'Package'}
//                                     </option>
//                                 ))}
//                             </select>
//                             {formik.touched.commitmentType && formik.errors.commitmentType && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         <span role="alert">{formik.errors.commitmentType as string}</span>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>
//                         {/* <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Select Package</label>
//                             <select
//                                 {...formik.getFieldProps('commitmentType')}
//                                 onChange={handleCommitmentTypeChange}
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 disabled={formik.isSubmitting || isCommitmentLoading}
//                             >
//                                 <option value="">Select type</option>
//                                 <option value="VOLUME_LINKED">Plastic Prevention</option>
//                                 <option value="USER_TYPE_LINKED">Households Engagement</option>
//                                 <option value="GENERAL">General</option>
//                             </select>
//                             {formik.touched.commitmentType && formik.errors.commitmentType && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         <span role="alert">{formik.errors.commitmentType as string}</span>
//                                     </div>
//                                 </div>
//                             )}
//                         </div> */}

//                         {/* <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Sub Type</label>
//                             <select
//                                 {...formik.getFieldProps('subType')}
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 disabled={!formik.values.commitmentType || formik.isSubmitting || isCommitmentLoading}
//                             >
//                                 <option value="">
//                                     {!formik.values.commitmentType ? 'Select commitment type first' : 'Select Sub Type'}
//                                 </option>
//                                 {getSubTypeOptions().map((option) => (
//                                     <option key={option.value} value={option.value}>
//                                         {option.label}
//                                     </option>
//                                 ))}
//                             </select>
//                             {formik.touched.subType && formik.errors.subType && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         <span role="alert">{formik.errors.subType as string}</span>
//                                     </div>
//                                 </div>
//                             )}
//                         </div> */}
//                     </div>

//                     {/* Row 3: Quantity, Household Target, Project Target */}
//                     {/* Row 3: Conditional Quantity Fields */}
//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                         {/* Show only for VOLUME_LINKED */}
//                         {formik.values.commitmentType === 'VOLUME_LINKED' && (
//                             <div className="fv-row mb-7">
//                                 <label className="required fw-bold fs-6 mb-2">Quantity</label>
//                                 <input
//                                     type="number"
//                                     placeholder="Enter Plastic prevention in kg"
//                                     step="0.1"
//                                     {...formik.getFieldProps('quantity')}
//                                     style={{
//                                         backgroundColor: '#ffffff',
//                                         border: '1px solid #dddddd',
//                                         color: '#000000',
//                                     }}
//                                     className="form-control form-control-solid mb-3 mb-lg-0"
//                                     autoComplete="off"
//                                     disabled={formik.isSubmitting || isCommitmentLoading}
//                                 />
//                                 {formik.touched.quantity && formik.errors.quantity && (
//                                     <div className="fv-plugins-message-container">
//                                         <div className="fv-help-block">
//                                             <span role="alert">{formik.errors.quantity as string}</span>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         )}

//                         {/* Show only for USER_TYPE_LINKED */}
//                         {formik.values.commitmentType === 'USER_TYPE_LINKED' && (
//                             <div className="fv-row mb-7">
//                                 <label className="required fw-bold fs-6 mb-2">Household Number Target</label>
//                                 <input
//                                     type="number"
//                                     placeholder="Enter household target"
//                                     step="1"
//                                     {...formik.getFieldProps('householdTarget')}
//                                     style={{
//                                         backgroundColor: '#ffffff',
//                                         border: '1px solid #dddddd',
//                                         color: '#000000',
//                                     }}
//                                     className="form-control form-control-solid mb-3 mb-lg-0"
//                                     autoComplete="off"
//                                     disabled={formik.isSubmitting || isCommitmentLoading}
//                                 />
//                                 {formik.touched.householdTarget && formik.errors.householdTarget && (
//                                     <div className="fv-plugins-message-container">
//                                         <div className="fv-help-block">
//                                             <span role="alert">{formik.errors.householdTarget as string}</span>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         )}

//                         {/* Show only for GENERAL */}
//                         {formik.values.commitmentType === 'GENERAL' && (
//                             <div className="fv-row mb-7">
//                                 <label className="required fw-bold fs-6 mb-2">Project Target</label>
//                                 <input
//                                     type="number"
//                                     placeholder="Enter project target"
//                                     step="1"
//                                     {...formik.getFieldProps('projectTarget')}
//                                     style={{
//                                         backgroundColor: '#ffffff',
//                                         border: '1px solid #dddddd',
//                                         color: '#000000',
//                                     }}
//                                     className="form-control form-control-solid mb-3 mb-lg-0"
//                                     autoComplete="off"
//                                     disabled={formik.isSubmitting || isCommitmentLoading}
//                                 />
//                                 {formik.touched.projectTarget && formik.errors.projectTarget && (
//                                     <div className="fv-plugins-message-container">
//                                         <div className="fv-help-block">
//                                             <span role="alert">{formik.errors.projectTarget as string}</span>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         )}
//                     </div>

//                     {/* Row 4: Start date & End date */}
//                     <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                         <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Start date</label>
//                             <input
//                                 type="date"
//                                 {...formik.getFieldProps('startDate')}
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 autoComplete="off"
//                                 disabled={formik.isSubmitting || isCommitmentLoading}
//                             />
//                             {formik.touched.startDate && formik.errors.startDate && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         <span role="alert">{formik.errors.startDate as string}</span>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>

//                         <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">End date</label>
//                             <input
//                                 type="date"
//                                 {...formik.getFieldProps('endDate')}
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 autoComplete="off"
//                                 disabled={formik.isSubmitting || isCommitmentLoading}
//                             />
//                             {formik.touched.endDate && formik.errors.endDate && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         <span role="alert">{formik.errors.endDate as string}</span>
//                                     </div>
//                                 </div>
//                             )}
//                         </div>

//                         {/* <div className="fv-row mb-7">
//                             <label className="required fw-bold fs-6 mb-2">Sponsorship Value (IDR)</label>
//                             <input
//                                 type="number"
//                                 placeholder="Enter sponsorship value"
//                                 step="0.01"
//                                 {...formik.getFieldProps('sponsorshipValue')}
//                                 style={{
//                                     backgroundColor: '#ffffff',
//                                     border: '1px solid #dddddd',
//                                     color: '#000000',
//                                 }}
//                                 className="form-control form-control-solid mb-3 mb-lg-0"
//                                 autoComplete="off"
//                                 disabled={formik.isSubmitting || isCommitmentLoading}
//                             />
//                             {formik.touched.sponsorshipValue && formik.errors.sponsorshipValue && (
//                                 <div className="fv-plugins-message-container">
//                                     <div className="fv-help-block">
//                                         <span role="alert">{formik.errors.sponsorshipValue as string}</span>
//                                     </div>
//                                 </div>
//                             )}
//                         </div> */}
//                     </div>

//                     {/* Submit Button */}
//                     <div className="text-center pt-15">
//                         <button
//                             type="submit"
//                             style={{ backgroundColor: '#000000' }}
//                             className="btn btn-primary"
//                             disabled={isCommitmentLoading || formik.isSubmitting || !formik.isValid}
//                         >
//                             <span className="indicator-label">
//                                 {isEdit ? 'Update' : 'Submit'}
//                             </span>
//                             {(formik.isSubmitting || isCommitmentLoading) && (
//                                 <span className="indicator-progress">
//                                     Please wait...{' '}
//                                     <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
//                                 </span>
//                             )}
//                         </button>
//                     </div>
//                 </div>
//             </form>
//         </div>
//         </div>
//     );
// };

// export default CommitmentForm1;









// import React, { useState, useEffect } from 'react';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import { User } from '../core/_models'
// import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'
// import { useNavigate } from 'react-router-dom'
// import CountryDropDown from '../../../../../../_metronic/helpers/countryDropDown';
// import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery';
// import { useLocation } from 'react-router-dom';


// interface CommitmentFormProps {
//     user?: User | any
//     isCommitmentLoading?: boolean;
//     commitment?: CommitmentData;
//     onClose?: () => void;
// }

// interface Sponsor {
//     id: string;
//     personalDetails?: {
//         name?: string;
//         email?: string;
//         mobile?: string;
//     };
//     companyDetails?: {
//         name?: string;
//         address?: string;
//     };
// }

// interface CommitmentData {
//     id?: string;
//     quantity: number;
//     categoryId: string;
//     sponsorId: string;
//     sponsorName: string;
//     itemId: string;
//     startDate: number;
//     endDate: number;
//     commitmentType: string;
//     subType: string;
//     remarks?: string;
//     orderId?: string;
//     householdTarget?: number;
//     projectTarget?: number;
//     sponsorshipValue?: number;
// }

// const CommitmentForm1: React.FC<CommitmentFormProps> = ({ user = {}, commitment = {}, isCommitmentLoading = false }) => {

//     const navigate = useNavigate()

//     const [loading, setLoading] = useState(false);
//     const [showToast, setShowToast] = useState(false);
//     const [toastMessage, setToastMessage] = useState('');
//     const [toastType, setToastType] = useState('success');

//     const [franchises, setFranchises] = useState<any[]>([]);
//     const [sponsors, setSponsors] = useState<Sponsor[]>([]);

//     const [loadingFranchises, setLoadingFranchises] = useState(false);
//     const [loadingSponsors, setLoadingSponsors] = useState(false);
//     const { pathname } = useLocation();

//     const isEdit = !!user?.id;

//     // New states for sponsor commitments
//     const [sponsorCommitments, setSponsorCommitments] = useState<any[]>([]);
//     const [loadingCommitments, setLoadingCommitments] = useState(false);
//     const [hasExistingCommitment, setHasExistingCommitment] = useState(false);

//     const { responseData: sponsorshipPackages } = useFetchCommon({
//         api: `sponsorship-packages?page=0&size=10`,
//         label: ['packageName'],
//         isDropDown: true,
//     })

//     const formatDateForInput = (dateValue: number | string) => {
//         if (!dateValue) return '';
//         const date = new Date(dateValue);
//         if (isNaN(date.getTime())) return '';
//         return date.toISOString().split('T')[0];
//     };

//     const [commitmentForEdit] = useState<any>({
//         ...user,
//         franchiseId: user?.franchiseId || user?.clientId || '',
//         sponsorId: user?.sponsorId || '',
//         sponsorName: user?.sponsorName || '',
//         commitmentType: user?.packageId || '',
//         packageName: user?.packageInfo?.packageName || '',
//         subType: user?.subType || '',
//         quantity: user?.quantity ? user.quantity.toString() : '',
//         householdTarget: user?.householdTarget ? user.householdTarget.toString() : '',
//         projectTarget: user?.projectTarget ? user.projectTarget.toString() : '',
//         startDate: user?.startDate ? formatDateForInput(user.startDate) : '',
//         endDate: user?.endDate ? formatDateForInput(user.endDate) : '',
//         remarks: user?.remarks || '',
//         sponsorshipValue: user?.sponsorshipValue ? user.sponsorshipValue.toString() : '',
//         country: user?.country || ''
//     });


//     const getTokenFromStorage = () => {
//         const authData = localStorage.getItem('kt-auth-react-v');
//         if (authData) {
//             try {
//                 const parsedData = JSON.parse(authData);
//                 return parsedData.data?.token;
//             } catch (e) {
//                 console.error('Error parsing auth data:', e);
//             }
//         }
//         return null;
//     };

//     const validationSchema = Yup.object({
//         franchiseId: Yup.string().required('Supply chain is required'),
//         sponsorId: Yup.string().required('Sponsor is required'),
//         commitmentType: Yup.string().required('Package type is required'),
//         startDate: Yup.date().required('Start date is required'),
//         endDate: Yup.date().required('End date is required'),
//     });

//     const formik = useFormik({
//         initialValues: commitmentForEdit,
//         validationSchema,
//         onSubmit: async (values, { setSubmitting }) => {
//             const token = getTokenFromStorage();
//             if (!token) {
//                 setToastType('error');
//                 setToastMessage('Authentication token not found. Please login again.');
//                 setShowToast(true);
//                 setTimeout(() => setShowToast(false), 3000);
//                 return;
//             }

//             setLoading(true);
//             setSubmitting(true);

//             try {
//                 const payload: any = {
//                     sponsorId: values.sponsorId,
//                     sponsorName: values.sponsorName,
//                     startDate: new Date(values.startDate).getTime(),
//                     endDate: new Date(values.endDate).getTime(),
//                     orderId: user?.orderId ? [user.orderId] : [`${Date.now()}_${Math.floor(Math.random() * 1000)}`],
//                     commitmentType: values.commitmentType,
//                     franchiseId: values.franchiseId,
//                     packageId: values.commitmentType
//                 };

//                 if (values.householdTarget) {
//                     payload.householdTarget = parseFloat(values.householdTarget);
//                 }
//                 if (values.projectTarget) {
//                     payload.projectTarget = parseFloat(values.projectTarget);
//                 }

//                 const isEdit = user?.id;
//                 const url = isEdit
//                     ? `${process.env.REACT_APP_BASE_API_URL}sponsorCommitments/${user.id}`
//                     : `${process.env.REACT_APP_BASE_API_URL}sponsorCommitments`;

//                 const method = isEdit ? 'PUT' : 'POST';

//                 const response = await fetch(url, {
//                     method: method,
//                     headers: {
//                         'token': token,
//                         'Content-Type': 'application/json',
//                         'franchiseeId': values.franchiseId
//                     },
//                     body: JSON.stringify(payload)
//                 });

//                 if (response.ok) {
//                     successToast(isEdit ? 'Commitment updated successfully!' : 'Commitment submitted successfully!')
//                     setTimeout(() => {
//                         window.location.reload();
//                     }, 1000);
//                     if (!isEdit) {
//                         formik.resetForm();
//                     }
//                 } else {
//                     const errorData = await response.json().catch(() => ({}));
//                     throw new Error(errorData.message || `Failed to ${isEdit ? 'update' : 'submit'} commitment`);
//                 }
//             } catch (error) {
//                 setToastType('error');
//                 setToastMessage((error as Error)?.message || `Failed to ${user?.id ? 'update' : 'submit'} commitment. Please try again.`);
//                 console.error('Submission error:', error);
//             } finally {
//                 setLoading(false);
//                 setSubmitting(false);
//                 setShowToast(true);
//                 setTimeout(() => setShowToast(false), 3000);
//             }
//         }
//     });

//     // Fetch sponsor commitments
//     const fetchSponsorCommitments = async (sponsorId: string) => {
//         const token = getTokenFromStorage();
//         if (!token || !sponsorId) return;

//         // Reset form fields first
//         formik.setFieldValue('commitmentType', '');
//         formik.setFieldValue('startDate', '');
//         formik.setFieldValue('endDate', '');
//         setHasExistingCommitment(false);

//         setLoadingCommitments(true);
//         try {
//             const response = await fetch(
//                 `${process.env.REACT_APP_BASE_API_URL}sponsorCommitments/sponsor/${sponsorId}?status=CREATED`,
//                 {
//                     headers: { 'Authorization': token }
//                 }
//             );
//             const data = await response.json();
//             setSponsorCommitments(data || []);

//             // If data exists, map the first commitment to form fields and disable
//             if (data && data.length > 0) {
//                 const commitment = data[0];
//                 setHasExistingCommitment(true);

//                 if (commitment.packageId) {
//                     formik.setFieldValue('commitmentType', commitment.packageId);
//                 }

//                 if (commitment.startDate) {
//                     formik.setFieldValue('startDate', new Date(commitment.startDate).toISOString().split('T')[0]);
//                 }

//                 if (commitment.endDate) {
//                     formik.setFieldValue('endDate', new Date(commitment.endDate).toISOString().split('T')[0]);
//                 }
//             }
//         } catch (error) {
//             console.error('Failed to fetch sponsor commitments:', error);
//         } finally {
//             setLoadingCommitments(false);
//         }
//     };

//     // Fetch functions
//     const fetchFranchises = async () => {
//         const token = getTokenFromStorage();
//         if (!token) return;

//         setLoadingFranchises(true);
//         try {
//             const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=FRANCHISE`, {
//                 headers: { 'token': token }
//             });
//             const data = await response.json();
//             setFranchises(data.content || data || []);
//         } catch (error) {
//             console.error('Failed to fetch franchises:', error);
//         } finally {
//             setLoadingFranchises(false);
//         }
//     };

//     const fetchSponsors = async () => {
//         const token = getTokenFromStorage();
//         if (!token) return;

//         setLoadingSponsors(true);
//         try {
//             const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=SPONSOR`, {
//                 headers: { 'token': token }
//             });
//             const data = await response.json();
//             setSponsors(data.content || data || []);
//         } catch (error) {
//             console.error('Failed to fetch sponsors:', error);
//         } finally {
//             setLoadingSponsors(false);
//         }
//     };

//     // Initial data loading
//     useEffect(() => {
//         fetchFranchises();
//     }, []);

//     useEffect(() => {
//         fetchSponsors();
//     }, []);

//     useEffect(() => {
//         if (sponsors.length > 0 && formik.values.sponsorId && isEdit) {
//             const selectedSponsor = sponsors.find(s => s.id === formik.values.sponsorId);
//             if (selectedSponsor) {
//                 const liveSponsorName = selectedSponsor.companyDetails?.name || selectedSponsor.personalDetails?.name || '';
//                 if (liveSponsorName !== formik.values.sponsorName) {
//                     formik.setFieldValue('sponsorName', liveSponsorName);
//                 }
//             }
//         }
//     }, [sponsors, formik.values.sponsorId, isEdit]);

//     // Fetch commitments on edit mode
//     useEffect(() => {
//         if (isEdit && formik.values.sponsorId) {
//             fetchSponsorCommitments(formik.values.sponsorId);
//         }
//     }, [isEdit]);

//     // Get sub type options based on commitment type
//     const getSubTypeOptions = () => {
//         switch (formik.values.commitmentType) {
//             case 'VOLUME_LINKED':
//                 return [
//                     { value: 'COLLECTION', label: 'Collection' },
//                     { value: 'RECYCLING', label: 'Recycling' }
//                 ];
//             case 'USER_TYPE_LINKED':
//                 return [
//                     { value: 'HOUSEHOLD', label: 'New Household' },
//                     { value: 'SOCIAL_BENEFIT', label: 'Social Benefit' }
//                 ];
//             case 'GENERAL':
//                 return [
//                     { value: 'GENERAL', label: 'General' }
//                 ];
//             default:
//                 return [];
//         }
//     };

//     // Get quantity placeholder based on commitment type
//     const getQuantityPlaceholder = () => {
//         switch (formik.values.commitmentType) {
//             case 'COLLECT':
//                 return 'Enter Plastic prevention in kg';
//             case 'HOUSEHOLDS_BENEFITED':
//                 return 'Enter household Target No.';
//             case 'CLEANUPS_CONDUCTED':
//                 return 'Enter project Target';
//             default:
//                 return 'Enter quantity';
//         }
//     };

//     // Handle commitment type change
//     const handleCommitmentTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//         const commitmentType = e.target.value;
//         formik.setFieldValue('commitmentType', commitmentType);
//         formik.setFieldValue('subType', '');
//     };

//     return (

//         <div className={pathname.includes('/apps/commitment/new') ? 'card' : ''} style={pathname.includes('/apps/commitment/new') ? { padding: "20px" } : {}}>
//             <div className="">
//                 {/* Toast Notification */}
//                 {showToast && (
//                     <div className={`fixed top-4 right-4 p-4 rounded-md shadow-lg z-50 ${toastType === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`}>
//                         {toastMessage}
//                     </div>
//                 )}

//                 {/* Warning message when sponsor has existing commitment */}
//                 {hasExistingCommitment && (
//                     <div className="alert alert-warning d-flex align-items-center mb-5" role="alert">
//                         <i className="bi bi-exclamation-triangle-fill me-2 fs-4"></i>
//                         <div>
//                             <strong>This sponsor already has an active commitment.</strong>
//                         </div>
//                     </div>
//                 )}

//                 <form onSubmit={formik.handleSubmit} noValidate>
//                     <div className="space-y-4">
//                         {/* Row 1: Supply chain & Sponsor */}
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                             <div className="fv-row mb-7">
//                                 <label className="required fw-bold fs-6 mb-2">Select Country</label>
//                                 <select
//                                     {...formik.getFieldProps('franchiseId')}
//                                     style={{
//                                         backgroundColor: hasExistingCommitment ? '#e9ecef' : '#ffffff',
//                                         border: '1px solid #dddddd',
//                                         color: '#000000',
//                                     }}
//                                     className="form-control form-control-solid mb-3 mb-lg-0"
//                                     disabled={loadingFranchises || formik.isSubmitting || isCommitmentLoading || hasExistingCommitment}
//                                 >
//                                     <option value="">{loadingFranchises ? 'Loading...' : 'Select Country'}</option>
//                                     {franchises.map((franchise) => (
//                                         <option key={franchise.id} value={franchise.id}>
//                                             {franchise.companyDetails?.name || franchise.personalDetails?.name || 'Unknown Supply chain'}
//                                         </option>
//                                     ))}
//                                 </select>
//                                 {formik.touched.franchiseId && formik.errors.franchiseId && (
//                                     <div className="fv-plugins-message-container">
//                                         <div className="fv-help-block">
//                                             <span role="alert">{formik.errors.franchiseId as string}</span>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="fv-row mb-7">
//                                 <label className="required fw-bold fs-6 mb-2">Select Sponsor</label>
//                                 <div className="position-relative">
//                                     <select
//                                         {...formik.getFieldProps('sponsorId')}
//                                         onChange={(e) => {
//                                             formik.handleChange(e);
//                                             const selectedSponsor = sponsors.find((s: Sponsor) => s.id === e.target.value);
//                                             formik.setFieldValue('sponsorName', selectedSponsor?.companyDetails?.name || selectedSponsor?.personalDetails?.name || '');

//                                             if (e.target.value) {
//                                                 fetchSponsorCommitments(e.target.value);
//                                             } else {
//                                                 // Reset when no sponsor selected
//                                                 setSponsorCommitments([]);
//                                                 setHasExistingCommitment(false);
//                                                 formik.setFieldValue('commitmentType', '');
//                                                 formik.setFieldValue('startDate', '');
//                                                 formik.setFieldValue('endDate', '');
//                                             }
//                                         }}
//                                         style={{
//                                             backgroundColor: '#ffffff',
//                                             border: '1px solid #dddddd',
//                                             color: '#000000',
//                                             paddingLeft: (formik.values.sponsorId && user?.sponsorLogo) ? '45px' : '12px'
//                                         }}
//                                         className="form-control form-control-solid mb-3 mb-lg-0"
//                                         disabled={loadingSponsors || formik.isSubmitting || isCommitmentLoading}
//                                     >
//                                         <option value="">{loadingSponsors ? 'Loading...' : 'Select Sponsor'}</option>
//                                         {sponsors.map((sponsor: Sponsor) => (
//                                             <option key={sponsor.id} value={sponsor.id}>
//                                                 {sponsor.companyDetails?.name || sponsor.personalDetails?.name || 'Unknown Sponsor'}
//                                             </option>
//                                         ))}
//                                     </select>
//                                     {formik.values.sponsorId && user?.sponsorLogo && (
//                                         <img
//                                             src={user.sponsorLogo}
//                                             alt="sponsor logo"
//                                             className="position-absolute rounded-circle"
//                                             style={{
//                                                 width: '20px',
//                                                 height: '20px',
//                                                 left: '12px',
//                                                 top: '50%',
//                                                 transform: 'translateY(-50%)',
//                                                 objectFit: 'cover',
//                                                 pointerEvents: 'none'
//                                             }}
//                                             onError={(e) => {
//                                                 e.currentTarget.style.display = 'none';
//                                             }}
//                                         />
//                                     )}
//                                 </div>
//                                 {formik.touched.sponsorId && formik.errors.sponsorId && (
//                                     <div className="fv-plugins-message-container">
//                                         <div className="fv-help-block">
//                                             <span role="alert">{formik.errors.sponsorId as string}</span>
//                                         </div>
//                                     </div>
//                                 )}
//                                 {/* Loading indicator for commitments */}
//                                 {loadingCommitments && (
//                                     <div className="text-dark mt-1">
//                                         <span className="spinner-border spinner-border-sm me-2"></span>
//                                         Checking existing commitments...
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Row 2: Commitment Type & Sub Type */}
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                             <div className="fv-row mb-7">
//                                 <label className="required fw-bold fs-6 mb-2">Select Package</label>
//                                 <select
//                                     style={{
//                                         backgroundColor: hasExistingCommitment ? '#e9ecef' : '#ffffff',
//                                         border: '1px solid #dddddd',
//                                         color: formik.values.commitmentType ? '#000000' : '#9da4ba'
//                                     }}
//                                     className="form-control form-control-solid mb-3 mb-lg-0"
//                                     {...formik.getFieldProps('commitmentType')}
//                                     onChange={handleCommitmentTypeChange}
//                                     disabled={formik.isSubmitting || isCommitmentLoading || hasExistingCommitment}
//                                 >
//                                     <option value="" style={{ color: '#9da4ba' }}>Select Package...</option>
//                                     {sponsorshipPackages?.map((pkg: any) => (
//                                         <option key={pkg.value} value={pkg.value} style={{ color: '#000000' }}>
//                                             {pkg.label || pkg.packageName || 'Package'}
//                                         </option>
//                                     ))}
//                                 </select>
//                                 {formik.touched.commitmentType && formik.errors.commitmentType && (
//                                     <div className="fv-plugins-message-container">
//                                         <div className="fv-help-block">
//                                             <span role="alert">{formik.errors.commitmentType as string}</span>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Row 3: Conditional Quantity Fields */}
//                         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                             {/* Show only for VOLUME_LINKED */}
//                             {formik.values.commitmentType === 'VOLUME_LINKED' && (
//                                 <div className="fv-row mb-7">
//                                     <label className="required fw-bold fs-6 mb-2">Quantity</label>
//                                     <input
//                                         type="number"
//                                         placeholder="Enter Plastic prevention in kg"
//                                         step="0.1"
//                                         {...formik.getFieldProps('quantity')}
//                                         style={{
//                                             backgroundColor: hasExistingCommitment ? '#e9ecef' : '#ffffff',
//                                             border: '1px solid #dddddd',
//                                             color: '#000000',
//                                         }}
//                                         className="form-control form-control-solid mb-3 mb-lg-0"
//                                         autoComplete="off"
//                                         disabled={formik.isSubmitting || isCommitmentLoading || hasExistingCommitment}
//                                     />
//                                     {formik.touched.quantity && formik.errors.quantity && (
//                                         <div className="fv-plugins-message-container">
//                                             <div className="fv-help-block">
//                                                 <span role="alert">{formik.errors.quantity as string}</span>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             )}

//                             {/* Show only for USER_TYPE_LINKED */}
//                             {formik.values.commitmentType === 'USER_TYPE_LINKED' && (
//                                 <div className="fv-row mb-7">
//                                     <label className="required fw-bold fs-6 mb-2">Household Number Target</label>
//                                     <input
//                                         type="number"
//                                         placeholder="Enter household target"
//                                         step="1"
//                                         {...formik.getFieldProps('householdTarget')}
//                                         style={{
//                                             backgroundColor: hasExistingCommitment ? '#e9ecef' : '#ffffff',
//                                             border: '1px solid #dddddd',
//                                             color: '#000000',
//                                         }}
//                                         className="form-control form-control-solid mb-3 mb-lg-0"
//                                         autoComplete="off"
//                                         disabled={formik.isSubmitting || isCommitmentLoading || hasExistingCommitment}
//                                     />
//                                     {formik.touched.householdTarget && formik.errors.householdTarget && (
//                                         <div className="fv-plugins-message-container">
//                                             <div className="fv-help-block">
//                                                 <span role="alert">{formik.errors.householdTarget as string}</span>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             )}

//                             {/* Show only for GENERAL */}
//                             {formik.values.commitmentType === 'GENERAL' && (
//                                 <div className="fv-row mb-7">
//                                     <label className="required fw-bold fs-6 mb-2">Project Target</label>
//                                     <input
//                                         type="number"
//                                         placeholder="Enter project target"
//                                         step="1"
//                                         {...formik.getFieldProps('projectTarget')}
//                                         style={{
//                                             backgroundColor: hasExistingCommitment ? '#e9ecef' : '#ffffff',
//                                             border: '1px solid #dddddd',
//                                             color: '#000000',
//                                         }}
//                                         className="form-control form-control-solid mb-3 mb-lg-0"
//                                         autoComplete="off"
//                                         disabled={formik.isSubmitting || isCommitmentLoading || hasExistingCommitment}
//                                     />
//                                     {formik.touched.projectTarget && formik.errors.projectTarget && (
//                                         <div className="fv-plugins-message-container">
//                                             <div className="fv-help-block">
//                                                 <span role="alert">{formik.errors.projectTarget as string}</span>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             )}
//                         </div>

//                         {/* Row 4: Start date & End date */}
//                         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                             <div className="fv-row mb-7">
//                                 <label className="required fw-bold fs-6 mb-2">Start date</label>
//                                 <input
//                                     type="date"
//                                     {...formik.getFieldProps('startDate')}
//                                     style={{
//                                         backgroundColor: hasExistingCommitment ? '#e9ecef' : '#ffffff',
//                                         border: '1px solid #dddddd',
//                                         color: '#000000',
//                                     }}
//                                     className="form-control form-control-solid mb-3 mb-lg-0"
//                                     autoComplete="off"
//                                     disabled={formik.isSubmitting || isCommitmentLoading || hasExistingCommitment}
//                                 />
//                                 {formik.touched.startDate && formik.errors.startDate && (
//                                     <div className="fv-plugins-message-container">
//                                         <div className="fv-help-block">
//                                             <span role="alert">{formik.errors.startDate as string}</span>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="fv-row mb-7">
//                                 <label className="required fw-bold fs-6 mb-2">End date</label>
//                                 <input
//                                     type="date"
//                                     {...formik.getFieldProps('endDate')}
//                                     style={{
//                                         backgroundColor: hasExistingCommitment ? '#e9ecef' : '#ffffff',
//                                         border: '1px solid #dddddd',
//                                         color: '#000000',
//                                     }}
//                                     className="form-control form-control-solid mb-3 mb-lg-0"
//                                     autoComplete="off"
//                                     disabled={formik.isSubmitting || isCommitmentLoading || hasExistingCommitment}
//                                 />
//                                 {formik.touched.endDate && formik.errors.endDate && (
//                                     <div className="fv-plugins-message-container">
//                                         <div className="fv-help-block">
//                                             <span role="alert">{formik.errors.endDate as string}</span>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Submit Button */}
//                         <div className="text-center pt-15">
//                             <button
//                                 type="submit"
//                                 style={{
//                                     backgroundColor: hasExistingCommitment ? '#6c757d' : '#000000',
//                                     cursor: hasExistingCommitment ? 'not-allowed' : 'pointer'
//                                 }}
//                                 className="btn btn-primary"
//                                 disabled={isCommitmentLoading || formik.isSubmitting || !formik.isValid || hasExistingCommitment}
//                             >
//                                 <span className="indicator-label">
//                                     {hasExistingCommitment ? 'Commitment Already Exists' : (isEdit ? 'Update' : 'Submit')}
//                                 </span>
//                                 {(formik.isSubmitting || isCommitmentLoading) && (
//                                     <span className="indicator-progress">
//                                         Please wait...{' '}
//                                         <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
//                                     </span>
//                                 )}
//                             </button>
//                         </div>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default CommitmentForm1;





// import React, { useState, useEffect } from 'react';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import { User } from '../core/_models'
// import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'
// import { useNavigate } from 'react-router-dom'
// import CountryDropDown from '../../../../../../_metronic/helpers/countryDropDown';
// import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery';
// import { useLocation } from 'react-router-dom';


// interface CommitmentFormProps {
//     user?: User | any
//     isCommitmentLoading?: boolean;
//     commitment?: CommitmentData;
//     onClose?: () => void;
// }

// interface Sponsor {
//     id: string;
//     personalDetails?: {
//         name?: string;
//         email?: string;
//         mobile?: string;
//     };
//     companyDetails?: {
//         name?: string;
//         address?: string;
//     };
// }

// interface CommitmentData {
//     id?: string;
//     quantity: number;
//     categoryId: string;
//     sponsorId: string;
//     sponsorName: string;
//     itemId: string;
//     startDate: number;
//     endDate: number;
//     commitmentType: string;
//     subType: string;
//     remarks?: string;
//     orderId?: string;
//     householdTarget?: number;
//     projectTarget?: number;
//     sponsorshipValue?: number;
// }

// const CommitmentForm1: React.FC<CommitmentFormProps> = ({ user = {}, commitment = {}, isCommitmentLoading = false }) => {

//     const navigate = useNavigate()

//     const [loading, setLoading] = useState(false);
//     const [showToast, setShowToast] = useState(false);
//     const [toastMessage, setToastMessage] = useState('');
//     const [toastType, setToastType] = useState('success');

//     const [franchises, setFranchises] = useState<any[]>([]);
//     const [sponsors, setSponsors] = useState<Sponsor[]>([]);

//     const [loadingFranchises, setLoadingFranchises] = useState(false);
//     const [loadingSponsors, setLoadingSponsors] = useState(false);
//     const { pathname } = useLocation();

//     const isEdit = !!user?.id;

//     // Check if commitment is completed
//     const isCompleted = isEdit && user?.status === 'COMPLETED';

//     // New states for sponsor commitments
//     const [sponsorCommitments, setSponsorCommitments] = useState<any[]>([]);
//     const [loadingCommitments, setLoadingCommitments] = useState(false);
//     const [hasExistingCommitment, setHasExistingCommitment] = useState(false);

//     const { responseData: sponsorshipPackages } = useFetchCommon({
//         api: `sponsorship-packages?page=0&size=10`,
//         label: ['packageName'],
//         isDropDown: true,
//     })

//     const formatDateForInput = (dateValue: number | string) => {
//         if (!dateValue) return '';
//         const date = new Date(dateValue);
//         if (isNaN(date.getTime())) return '';
//         return date.toISOString().split('T')[0];
//     };

//     const [commitmentForEdit] = useState<any>({
//         ...user,
//         franchiseId: user?.franchiseId || user?.clientId || '',
//         sponsorId: user?.sponsorId || '',
//         sponsorName: user?.sponsorName || '',
//         commitmentType: user?.packageId || '',
//         packageName: user?.packageInfo?.packageName || '',
//         subType: user?.subType || '',
//         quantity: user?.quantity ? user.quantity.toString() : '',
//         householdTarget: user?.householdTarget ? user.householdTarget.toString() : '',
//         projectTarget: user?.projectTarget ? user.projectTarget.toString() : '',
//         startDate: user?.startDate ? formatDateForInput(user.startDate) : '',
//         endDate: user?.endDate ? formatDateForInput(user.endDate) : '',
//         remarks: user?.remarks || '',
//         sponsorshipValue: user?.sponsorshipValue ? user.sponsorshipValue.toString() : '',
//         country: user?.country || ''
//     });


//     const getTokenFromStorage = () => {
//         const authData = localStorage.getItem('kt-auth-react-v');
//         if (authData) {
//             try {
//                 const parsedData = JSON.parse(authData);
//                 return parsedData.data?.token;
//             } catch (e) {
//                 console.error('Error parsing auth data:', e);
//             }
//         }
//         return null;
//     };

//     const validationSchema = Yup.object({
//         franchiseId: Yup.string().required('Supply chain is required'),
//         sponsorId: Yup.string().required('Sponsor is required'),
//         commitmentType: Yup.string().required('Package type is required'),
//         startDate: Yup.date().required('Start date is required'),
//         endDate: Yup.date().required('End date is required'),
//     });

//     const formik = useFormik({
//         initialValues: commitmentForEdit,
//         validationSchema,
//         onSubmit: async (values, { setSubmitting }) => {
//             const token = getTokenFromStorage();
//             if (!token) {
//                 setToastType('error');
//                 setToastMessage('Authentication token not found. Please login again.');
//                 setShowToast(true);
//                 setTimeout(() => setShowToast(false), 3000);
//                 return;
//             }

//             setLoading(true);
//             setSubmitting(true);

//             try {
//                 const payload: any = {
//                     sponsorId: values.sponsorId,
//                     sponsorName: values.sponsorName,
//                     startDate: new Date(values.startDate).getTime(),
//                     endDate: new Date(values.endDate).getTime(),
//                     orderId: user?.orderId ? [user.orderId] : [`${Date.now()}_${Math.floor(Math.random() * 1000)}`],
//                     commitmentType: values.commitmentType,
//                     franchiseId: values.franchiseId,
//                     packageId: values.commitmentType
//                 };

//                 if (values.householdTarget) {
//                     payload.householdTarget = parseFloat(values.householdTarget);
//                 }
//                 if (values.projectTarget) {
//                     payload.projectTarget = parseFloat(values.projectTarget);
//                 }

//                 const isEdit = user?.id;
//                 const url = isEdit
//                     ? `${process.env.REACT_APP_BASE_API_URL}sponsorCommitments/${user.id}`
//                     : `${process.env.REACT_APP_BASE_API_URL}sponsorCommitments`;

//                 const method = isEdit ? 'PUT' : 'POST';

//                 const response = await fetch(url, {
//                     method: method,
//                     headers: {
//                         'token': token,
//                         'Content-Type': 'application/json',
//                         'franchiseeId': values.franchiseId
//                     },
//                     body: JSON.stringify(payload)
//                 });

//                 if (response.ok) {
//                     successToast(isEdit ? 'Commitment updated successfully!' : 'Commitment submitted successfully!')
//                     setTimeout(() => {
//                         window.location.reload();
//                     }, 1000);
//                     if (!isEdit) {
//                         formik.resetForm();
//                     }
//                 } else {
//                     const errorData = await response.json().catch(() => ({}));
//                     throw new Error(errorData.message || `Failed to ${isEdit ? 'update' : 'submit'} commitment`);
//                 }
//             } catch (error) {
//                 setToastType('error');
//                 setToastMessage((error as Error)?.message || `Failed to ${user?.id ? 'update' : 'submit'} commitment. Please try again.`);
//                 console.error('Submission error:', error);
//             } finally {
//                 setLoading(false);
//                 setSubmitting(false);
//                 setShowToast(true);
//                 setTimeout(() => setShowToast(false), 3000);
//             }
//         }
//     });

//     // Fetch sponsor commitments
// // Fetch sponsor commitments
// const fetchSponsorCommitments = async (sponsorId: string) => {
//     const token = getTokenFromStorage();
//     if (!token || !sponsorId) return;

//     // Reset form fields only if NOT in edit mode
//     if (!isEdit) {
//         formik.setFieldValue('commitmentType', '');
//         formik.setFieldValue('startDate', '');
//         formik.setFieldValue('endDate', '');
//     }
//     setHasExistingCommitment(false);

//     setLoadingCommitments(true);
//     try {
//         const response = await fetch(
//             `${process.env.REACT_APP_BASE_API_URL}sponsorCommitments/sponsor/${sponsorId}?status=CREATED`,
//             {
//                 headers: { 'Authorization': token }
//             }
//         );
//         const data = await response.json();

//         // Filter out the current commitment if in edit mode
//         let filteredData = data || [];
//         if (isEdit && user?.id) {
//             filteredData = filteredData.filter((commitment: any) => commitment.id !== user.id);
//         }

//         setSponsorCommitments(filteredData);

//         // Only set hasExistingCommitment if there are OTHER commitments (excluding current one)
//         if (filteredData && filteredData.length > 0) {
//             const commitment = filteredData[0];
//             setHasExistingCommitment(true);

//             if (commitment.packageId) {
//                 formik.setFieldValue('commitmentType', commitment.packageId);
//             }

//             if (commitment.startDate) {
//                 formik.setFieldValue('startDate', new Date(commitment.startDate).toISOString().split('T')[0]);
//             }

//             if (commitment.endDate) {
//                 formik.setFieldValue('endDate', new Date(commitment.endDate).toISOString().split('T')[0]);
//             }
//         }
//     } catch (error) {
//         console.error('Failed to fetch sponsor commitments:', error);
//     } finally {
//         setLoadingCommitments(false);
//     }
// };
//     // Fetch functions
//     const fetchFranchises = async () => {
//         const token = getTokenFromStorage();
//         if (!token) return;

//         setLoadingFranchises(true);
//         try {
//             const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=FRANCHISE`, {
//                 headers: { 'token': token }
//             });
//             const data = await response.json();
//             setFranchises(data.content || data || []);
//         } catch (error) {
//             console.error('Failed to fetch franchises:', error);
//         } finally {
//             setLoadingFranchises(false);
//         }
//     };

//     const fetchSponsors = async () => {
//         const token = getTokenFromStorage();
//         if (!token) return;

//         setLoadingSponsors(true);
//         try {
//             const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=SPONSOR`, {
//                 headers: { 'token': token }
//             });
//             const data = await response.json();
//             setSponsors(data.content || data || []);
//         } catch (error) {
//             console.error('Failed to fetch sponsors:', error);
//         } finally {
//             setLoadingSponsors(false);
//         }
//     };

//     // Initial data loading
//     useEffect(() => {
//         fetchFranchises();
//     }, []);

//     useEffect(() => {
//         fetchSponsors();
//     }, []);

//     useEffect(() => {
//         if (sponsors.length > 0 && formik.values.sponsorId && isEdit) {
//             const selectedSponsor = sponsors.find(s => s.id === formik.values.sponsorId);
//             if (selectedSponsor) {
//                 const liveSponsorName = selectedSponsor.companyDetails?.name || selectedSponsor.personalDetails?.name || '';
//                 if (liveSponsorName !== formik.values.sponsorName) {
//                     formik.setFieldValue('sponsorName', liveSponsorName);
//                 }
//             }
//         }
//     }, [sponsors, formik.values.sponsorId, isEdit]);

//     // Fetch commitments on edit mode - but only if not completed
//     useEffect(() => {
//         if (isEdit && formik.values.sponsorId && !isCompleted) {
//             fetchSponsorCommitments(formik.values.sponsorId);
//         }
//     }, [isEdit, isCompleted]);

//     // Get sub type options based on commitment type
//     const getSubTypeOptions = () => {
//         switch (formik.values.commitmentType) {
//             case 'VOLUME_LINKED':
//                 return [
//                     { value: 'COLLECTION', label: 'Collection' },
//                     { value: 'RECYCLING', label: 'Recycling' }
//                 ];
//             case 'USER_TYPE_LINKED':
//                 return [
//                     { value: 'HOUSEHOLD', label: 'New Household' },
//                     { value: 'SOCIAL_BENEFIT', label: 'Social Benefit' }
//                 ];
//             case 'GENERAL':
//                 return [
//                     { value: 'GENERAL', label: 'General' }
//                 ];
//             default:
//                 return [];
//         }
//     };

//     // Get quantity placeholder based on commitment type
//     const getQuantityPlaceholder = () => {
//         switch (formik.values.commitmentType) {
//             case 'COLLECT':
//                 return 'Enter Plastic prevention in kg';
//             case 'HOUSEHOLDS_BENEFITED':
//                 return 'Enter household Target No.';
//             case 'CLEANUPS_CONDUCTED':
//                 return 'Enter project Target';
//             default:
//                 return 'Enter quantity';
//         }
//     };

//     // Handle commitment type change
//     const handleCommitmentTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//         const commitmentType = e.target.value;
//         formik.setFieldValue('commitmentType', commitmentType);
//         formik.setFieldValue('subType', '');
//     };

//     return (

//         <div className={pathname.includes('/apps/commitment/new') ? 'card' : ''} style={pathname.includes('/apps/commitment/new') ? { padding: "20px" } : {}}>
//             <div className="">
//                 {/* Toast Notification */}
//                 {showToast && (
//                     <div className={`fixed top-4 right-4 p-4 rounded-md shadow-lg z-50 ${toastType === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`}>
//                         {toastMessage}
//                     </div>
//                 )}

//                 {/* Warning message when sponsor has existing commitment */}
//                 {hasExistingCommitment && !isCompleted && (
//                     <div className="alert alert-warning d-flex align-items-center mb-5" role="alert">
//                         <i className="bi bi-exclamation-triangle-fill me-2 fs-4"></i>
//                         <div>
//                             <strong>This sponsor already has an active commitment.</strong>
//                         </div>
//                     </div>
//                 )}

//                 {/* Warning message when commitment is completed */}
//                 {isCompleted && (
//                     <div className="alert alert-info d-flex align-items-center mb-5" role="alert">
//                         <i className="bi bi-info-circle-fill me-2 fs-4"></i>
//                         <div>
//                             <strong>This commitment is completed and cannot be edited.</strong>
//                         </div>
//                     </div>
//                 )}

//                 <form onSubmit={formik.handleSubmit} noValidate>
//                     <div className="space-y-4">
//                         {/* Row 1: Supply chain & Sponsor */}
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                             <div className="fv-row mb-7">
//                                 <label className="required fw-bold fs-6 mb-2">Select Country</label>
//                                 <select
//                                     {...formik.getFieldProps('franchiseId')}
//                                     style={{
//                                         backgroundColor: (hasExistingCommitment || isCompleted) ? '#e9ecef' : '#ffffff',
//                                         border: '1px solid #dddddd',
//                                         color: '#000000',
//                                     }}
//                                     className="form-control form-control-solid mb-3 mb-lg-0"
//                                  disabled={loadingFranchises || formik.isSubmitting || isCommitmentLoading || hasExistingCommitment || isCompleted || isEdit}
//                                 >
//                                     <option value="">{loadingFranchises ? 'Loading...' : 'Select Country'}</option>
//                                     {franchises.map((franchise) => (
//                                         <option key={franchise.id} value={franchise.id}>
//                                             {franchise.companyDetails?.name || franchise.personalDetails?.name || 'Unknown Supply chain'}
//                                         </option>
//                                     ))}
//                                 </select>
//                                 {formik.touched.franchiseId && formik.errors.franchiseId && (
//                                     <div className="fv-plugins-message-container">
//                                         <div className="fv-help-block">
//                                             <span role="alert">{formik.errors.franchiseId as string}</span>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="fv-row mb-7">
//                                 <label className="required fw-bold fs-6 mb-2">Select Sponsor</label>
//                                 <div className="position-relative">
//                                     <select
//                                         {...formik.getFieldProps('sponsorId')}
//                                         onChange={(e) => {
//                                             formik.handleChange(e);
//                                             const selectedSponsor = sponsors.find((s: Sponsor) => s.id === e.target.value);
//                                             formik.setFieldValue('sponsorName', selectedSponsor?.companyDetails?.name || selectedSponsor?.personalDetails?.name || '');

//                                             if (e.target.value && !isCompleted) {
//                                                 fetchSponsorCommitments(e.target.value);
//                                             } else {
//                                                 // Reset when no sponsor selected
//                                                 setSponsorCommitments([]);
//                                                 setHasExistingCommitment(false);
//                                                 formik.setFieldValue('commitmentType', '');
//                                                 formik.setFieldValue('startDate', '');
//                                                 formik.setFieldValue('endDate', '');
//                                             }
//                                         }}
//                                         style={{
//                                             backgroundColor: isCompleted ? '#e9ecef' : '#ffffff',
//                                             border: '1px solid #dddddd',
//                                             color: '#000000',
//                                             paddingLeft: (formik.values.sponsorId && user?.sponsorLogo) ? '45px' : '12px'
//                                         }}
//                                         className="form-control form-control-solid mb-3 mb-lg-0"
//                                        disabled={loadingSponsors || formik.isSubmitting || isCommitmentLoading || isCompleted || isEdit}
//                                     >
//                                         <option value="">{loadingSponsors ? 'Loading...' : 'Select Sponsor'}</option>
//                                         {sponsors.map((sponsor: Sponsor) => (
//                                             <option key={sponsor.id} value={sponsor.id}>
//                                                 {sponsor.companyDetails?.name || sponsor.personalDetails?.name || 'Unknown Sponsor'}
//                                             </option>
//                                         ))}
//                                     </select>
//                                     {formik.values.sponsorId && user?.sponsorLogo && (
//                                         <img
//                                             src={user.sponsorLogo}
//                                             alt="sponsor logo"
//                                             className="position-absolute rounded-circle"
//                                             style={{
//                                                 width: '20px',
//                                                 height: '20px',
//                                                 left: '12px',
//                                                 top: '50%',
//                                                 transform: 'translateY(-50%)',
//                                                 objectFit: 'cover',
//                                                 pointerEvents: 'none'
//                                             }}
//                                             onError={(e) => {
//                                                 e.currentTarget.style.display = 'none';
//                                             }}
//                                         />
//                                     )}
//                                 </div>
//                                 {formik.touched.sponsorId && formik.errors.sponsorId && (
//                                     <div className="fv-plugins-message-container">
//                                         <div className="fv-help-block">
//                                             <span role="alert">{formik.errors.sponsorId as string}</span>
//                                         </div>
//                                     </div>
//                                 )}
//                                 {/* Loading indicator for commitments */}
//                                 {loadingCommitments && !isCompleted && (
//                                     <div className="text-dark mt-1">
//                                         <span className="spinner-border spinner-border-sm me-2"></span>
//                                         Checking existing commitments...
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Row 2: Commitment Type & Sub Type */}
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                             <div className="fv-row mb-7">
//                                 <label className="required fw-bold fs-6 mb-2">Select Package</label>
//                                 <select
//                                     style={{
//                                         backgroundColor: (hasExistingCommitment || isCompleted) ? '#e9ecef' : '#ffffff',
//                                         border: '1px solid #dddddd',
//                                         color: formik.values.commitmentType ? '#000000' : '#9da4ba'
//                                     }}
//                                     className="form-control form-control-solid mb-3 mb-lg-0"
//                                     {...formik.getFieldProps('commitmentType')}
//                                     onChange={handleCommitmentTypeChange}
//                                    disabled={formik.isSubmitting || isCommitmentLoading || hasExistingCommitment || isCompleted || isEdit}
//                                 >
//                                     <option value="" style={{ color: '#9da4ba' }}>Select Package...</option>
//                                     {sponsorshipPackages?.map((pkg: any) => (
//                                         <option key={pkg.value} value={pkg.value} style={{ color: '#000000' }}>
//                                             {pkg.label || pkg.packageName || 'Package'}
//                                         </option>
//                                     ))}
//                                 </select>
//                                 {formik.touched.commitmentType && formik.errors.commitmentType && (
//                                     <div className="fv-plugins-message-container">
//                                         <div className="fv-help-block">
//                                             <span role="alert">{formik.errors.commitmentType as string}</span>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Row 3: Conditional Quantity Fields */}
//                         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                             {/* Show only for VOLUME_LINKED */}
//                             {formik.values.commitmentType === 'VOLUME_LINKED' && (
//                                 <div className="fv-row mb-7">
//                                     <label className="required fw-bold fs-6 mb-2">Quantity</label>
//                                     <input
//                                         type="number"
//                                         placeholder="Enter Plastic prevention in kg"
//                                         step="0.1"
//                                         {...formik.getFieldProps('quantity')}
//                                         style={{
//                                             backgroundColor: (hasExistingCommitment || isCompleted) ? '#e9ecef' : '#ffffff',
//                                             border: '1px solid #dddddd',
//                                             color: '#000000',
//                                         }}
//                                         className="form-control form-control-solid mb-3 mb-lg-0"
//                                         autoComplete="off"
//                                         disabled={formik.isSubmitting || isCommitmentLoading || hasExistingCommitment || isCompleted}
//                                     />
//                                     {formik.touched.quantity && formik.errors.quantity && (
//                                         <div className="fv-plugins-message-container">
//                                             <div className="fv-help-block">
//                                                 <span role="alert">{formik.errors.quantity as string}</span>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             )}

//                             {/* Show only for USER_TYPE_LINKED */}
//                             {formik.values.commitmentType === 'USER_TYPE_LINKED' && (
//                                 <div className="fv-row mb-7">
//                                     <label className="required fw-bold fs-6 mb-2">Household Number Target</label>
//                                     <input
//                                         type="number"
//                                         placeholder="Enter household target"
//                                         step="1"
//                                         {...formik.getFieldProps('householdTarget')}
//                                         style={{
//                                             backgroundColor: (hasExistingCommitment || isCompleted) ? '#e9ecef' : '#ffffff',
//                                             border: '1px solid #dddddd',
//                                             color: '#000000',
//                                         }}
//                                         className="form-control form-control-solid mb-3 mb-lg-0"
//                                         autoComplete="off"
//                                         disabled={formik.isSubmitting || isCommitmentLoading || hasExistingCommitment || isCompleted}
//                                     />
//                                     {formik.touched.householdTarget && formik.errors.householdTarget && (
//                                         <div className="fv-plugins-message-container">
//                                             <div className="fv-help-block">
//                                                 <span role="alert">{formik.errors.householdTarget as string}</span>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             )}

//                             {/* Show only for GENERAL */}
//                             {formik.values.commitmentType === 'GENERAL' && (
//                                 <div className="fv-row mb-7">
//                                     <label className="required fw-bold fs-6 mb-2">Project Target</label>
//                                     <input
//                                         type="number"
//                                         placeholder="Enter project target"
//                                         step="1"
//                                         {...formik.getFieldProps('projectTarget')}
//                                         style={{
//                                             backgroundColor: (hasExistingCommitment || isCompleted) ? '#e9ecef' : '#ffffff',
//                                             border: '1px solid #dddddd',
//                                             color: '#000000',
//                                         }}
//                                         className="form-control form-control-solid mb-3 mb-lg-0"
//                                         autoComplete="off"
//                                         disabled={formik.isSubmitting || isCommitmentLoading || hasExistingCommitment || isCompleted}
//                                     />
//                                     {formik.touched.projectTarget && formik.errors.projectTarget && (
//                                         <div className="fv-plugins-message-container">
//                                             <div className="fv-help-block">
//                                                 <span role="alert">{formik.errors.projectTarget as string}</span>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             )}
//                         </div>

//                         {/* Row 4: Start date & End date */}
//                         <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                             <div className="fv-row mb-7">
//                                 <label className="required fw-bold fs-6 mb-2">Start date</label>
//                                 <input
//                                     type="date"
//                                     {...formik.getFieldProps('startDate')}
//                                     style={{
//                                         backgroundColor: (hasExistingCommitment || isCompleted) ? '#e9ecef' : '#ffffff',
//                                         border: '1px solid #dddddd',
//                                         color: '#000000',
//                                     }}
//                                     className="form-control form-control-solid mb-3 mb-lg-0"
//                                     autoComplete="off"
//                                     disabled={formik.isSubmitting || isCommitmentLoading || hasExistingCommitment || isCompleted}
//                                 />
//                                 {formik.touched.startDate && formik.errors.startDate && (
//                                     <div className="fv-plugins-message-container">
//                                         <div className="fv-help-block">
//                                             <span role="alert">{formik.errors.startDate as string}</span>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>

//                             <div className="fv-row mb-7">
//                                 <label className="required fw-bold fs-6 mb-2">End date</label>
//                                 <input
//                                     type="date"
//                                     {...formik.getFieldProps('endDate')}
//                                     style={{
//                                         backgroundColor: (hasExistingCommitment || isCompleted) ? '#e9ecef' : '#ffffff',
//                                         border: '1px solid #dddddd',
//                                         color: '#000000',
//                                     }}
//                                     className="form-control form-control-solid mb-3 mb-lg-0"
//                                     autoComplete="off"
//                                     disabled={formik.isSubmitting || isCommitmentLoading || hasExistingCommitment || isCompleted}
//                                 />
//                                 {formik.touched.endDate && formik.errors.endDate && (
//                                     <div className="fv-plugins-message-container">
//                                         <div className="fv-help-block">
//                                             <span role="alert">{formik.errors.endDate as string}</span>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Submit Button */}
//                         <div className="text-center pt-15">
//                             <button
//                                 type="submit"
//                                 style={{
//                                     backgroundColor: (hasExistingCommitment || isCompleted) ? '#6c757d' : '#000000',
//                                     cursor: (hasExistingCommitment || isCompleted) ? 'not-allowed' : 'pointer'
//                                 }}
//                                 className="btn btn-primary"
//                                 disabled={isCommitmentLoading || formik.isSubmitting || !formik.isValid || hasExistingCommitment || isCompleted}
//                             >
//                                 <span className="indicator-label">
//                                     {isCompleted ? 'Commitment Completed - Cannot Edit' :
//                                         hasExistingCommitment ? 'Commitment Already Exists' :
//                                             (isEdit ? 'Update' : 'Submit')}
//                                 </span>
//                                 {(formik.isSubmitting || isCommitmentLoading) && (
//                                     <span className="indicator-progress">
//                                         Please wait...{' '}
//                                         <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
//                                     </span>
//                                 )}
//                             </button>
//                         </div>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default CommitmentForm1;







import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { User } from '../core/_models'
import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'
import { useNavigate } from 'react-router-dom'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery';
import { useLocation } from 'react-router-dom';

interface CommitmentFormProps {
    user?: User | any
    isCommitmentLoading?: boolean;
    commitment?: CommitmentData;
    onClose?: () => void;
}

interface Sponsor {
    id: string;
    personalDetails?: { name?: string; email?: string; mobile?: string; };
    companyDetails?: { name?: string; address?: string; };
}

interface CommitmentData {
    id?: string;
    quantity: number;
    categoryId: string;
    sponsorId: string;
    sponsorName: string;
    itemId: string;
    startDate: number;
    endDate: number;
    commitmentType: string;
    subType: string;
    remarks?: string;
    orderId?: string;
    householdTarget?: number;
    projectTarget?: number;
    sponsorshipValue?: number;
}

const CommitmentForm1: React.FC<CommitmentFormProps> = ({ user = {}, commitment = {}, isCommitmentLoading = false }) => {

    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastType, setToastType] = useState('success');
    const [franchises, setFranchises] = useState<any[]>([]);
    const [sponsors, setSponsors] = useState<Sponsor[]>([]);
    const [loadingFranchises, setLoadingFranchises] = useState(false);
    const [loadingSponsors, setLoadingSponsors] = useState(false);
    const { pathname } = useLocation();

    const isEdit = !!user?.id;
    const isCompleted = isEdit && user?.status === 'COMPLETED';

    const [sponsorCommitments, setSponsorCommitments] = useState<any[]>([]);
    const [loadingCommitments, setLoadingCommitments] = useState(false);
    const [hasExistingCommitment, setHasExistingCommitment] = useState(false);

    const { responseData: sponsorshipPackages } = useFetchCommon({
        api: `sponsorship-packages?page=0&size=10`,
        label: ['packageName'],
        isDropDown: true,
    })

    const formatDateForInput = (dateValue: number | string) => {
        if (!dateValue) return '';
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return '';
        return date.toISOString().split('T')[0];
    };

    const [commitmentForEdit] = useState<any>({
        ...user,
        franchiseId: user?.franchiseId || user?.clientId || '',
        sponsorId: user?.sponsorId || '',
        sponsorName: user?.sponsorName || '',
        commitmentType: user?.packageId || '',
        packageName: user?.packageInfo?.packageName || '',
        subType: user?.subType || '',
        quantity: user?.quantity ? user.quantity.toString() : '',
        householdTarget: user?.householdTarget ? user.householdTarget.toString() : '',
        projectTarget: user?.projectTarget ? user.projectTarget.toString() : '',
        startDate: user?.startDate ? formatDateForInput(user.startDate) : '',
        endDate: user?.endDate ? formatDateForInput(user.endDate) : '',
        remarks: user?.remarks || '',
        sponsorshipValue: user?.sponsorshipValue ? user.sponsorshipValue.toString() : '',
        country: user?.country || ''
    });

    const getTokenFromStorage = () => {
        const authData = localStorage.getItem('kt-auth-react-v');
        if (authData) {
            try {
                const parsedData = JSON.parse(authData);
                return parsedData.data?.token;
            } catch (e) {
                console.error('Error parsing auth data:', e);
            }
        }
        return null;
    };

    const validationSchema = Yup.object({
        franchiseId: isEdit
            ? Yup.string()
            : Yup.string().required('Supply chain is required'),
        sponsorId: Yup.string().required('Sponsor is required'),
        commitmentType: Yup.string().required('Package type is required'),
        startDate: Yup.date().required('Start date is required'),
        endDate: Yup.date().required('End date is required'),
    });

    const formik = useFormik({
        initialValues: commitmentForEdit,
        validationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            const token = getTokenFromStorage();
            if (!token) {
                setToastType('error');
                setToastMessage('Authentication token not found. Please login again.');
                setShowToast(true);
                setTimeout(() => setShowToast(false), 3000);
                return;
            }

            setLoading(true);
            setSubmitting(true);

            try {
                const payload: any = {
                    sponsorId: values.sponsorId,
                    sponsorName: values.sponsorName,
                    startDate: new Date(values.startDate).getTime(),
                    endDate: new Date(values.endDate).getTime(),
                    orderId: user?.orderId ? [user.orderId] : [`${Date.now()}_${Math.floor(Math.random() * 1000)}`],
                    commitmentType: values.commitmentType,
                    franchiseId: values.franchiseId,
                    packageId: values.commitmentType
                };

                if (values.householdTarget) payload.householdTarget = parseFloat(values.householdTarget);
                if (values.projectTarget) payload.projectTarget = parseFloat(values.projectTarget);

                const url = isEdit
                    ? `${process.env.REACT_APP_BASE_API_URL}sponsorCommitments/${user.id}`
                    : `${process.env.REACT_APP_BASE_API_URL}sponsorCommitments`;

                const method = isEdit ? 'PUT' : 'POST';

                const response = await fetch(url, {
                    method,
                    headers: {
                        'token': token,
                        'Content-Type': 'application/json',
                        'franchiseeId': values.franchiseId
                    },
                    body: JSON.stringify(payload)
                });

                if (response.ok) {
                    successToast(isEdit ? 'Commitment updated successfully!' : 'Commitment submitted successfully!')
                    setTimeout(() => { window.location.reload(); }, 1000);
                    if (!isEdit) formik.resetForm();
                } else {
                    const errorData = await response.json().catch(() => ({}));
                    throw new Error(errorData.message || `Failed to ${isEdit ? 'update' : 'submit'} commitment`);
                }
            } catch (error) {
                setToastType('error');
                setToastMessage((error as Error)?.message || `Failed to ${user?.id ? 'update' : 'submit'} commitment. Please try again.`);
                console.error('Submission error:', error);
            } finally {
                setLoading(false);
                setSubmitting(false);
                setShowToast(true);
                setTimeout(() => setShowToast(false), 3000);
            }
        }
    });

    const fetchSponsorCommitments = async (sponsorId: string) => {
        const token = getTokenFromStorage();
        if (!token || !sponsorId) return;

        if (!isEdit) {
            formik.setFieldValue('commitmentType', '');
            formik.setFieldValue('startDate', '');
            formik.setFieldValue('endDate', '');
        }
        setHasExistingCommitment(false);
        setLoadingCommitments(true);

        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_API_URL}sponsorCommitments/sponsor/${sponsorId}?status=CREATED`,
                { headers: { 'Authorization': token } }
            );
            const data = await response.json();

            let filteredData = data || [];
            if (isEdit && user?.id) {
                filteredData = filteredData.filter((c: any) => c.id !== user.id);
            }

            setSponsorCommitments(filteredData);

            if (filteredData && filteredData.length > 0 && !isEdit) {
                const commitment = filteredData[0];
                setHasExistingCommitment(true);

                if (commitment.packageId) formik.setFieldValue('commitmentType', commitment.packageId);
                if (commitment.startDate) formik.setFieldValue('startDate', new Date(commitment.startDate).toISOString().split('T')[0]);
                if (commitment.endDate) formik.setFieldValue('endDate', new Date(commitment.endDate).toISOString().split('T')[0]);
            }
        } catch (error) {
            console.error('Failed to fetch sponsor commitments:', error);
        } finally {
            setLoadingCommitments(false);
        }
    };

    const fetchFranchises = async () => {
        const token = getTokenFromStorage();
        if (!token) return;
        setLoadingFranchises(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=FRANCHISE`, {
                headers: { 'token': token }
            });
            const data = await response.json();
            setFranchises(data.content || data || []);
        } catch (error) {
            console.error('Failed to fetch franchises:', error);
        } finally {
            setLoadingFranchises(false);
        }
    };

    const fetchSponsors = async () => {
        const token = getTokenFromStorage();
        if (!token) return;
        setLoadingSponsors(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=SPONSOR`, {
                headers: { 'token': token }
            });
            const data = await response.json();
            setSponsors(data.content || data || []);
        } catch (error) {
            console.error('Failed to fetch sponsors:', error);
        } finally {
            setLoadingSponsors(false);
        }
    };

    useEffect(() => { fetchFranchises(); }, []);
    useEffect(() => { fetchSponsors(); }, []);

    useEffect(() => {
        if (sponsors.length > 0 && formik.values.sponsorId && isEdit) {
            const selectedSponsor = sponsors.find(s => s.id === formik.values.sponsorId);
            if (selectedSponsor) {
                const liveSponsorName = selectedSponsor.companyDetails?.name || selectedSponsor.personalDetails?.name || '';
                if (liveSponsorName !== formik.values.sponsorName) {
                    formik.setFieldValue('sponsorName', liveSponsorName);
                }
            }
        }
    }, [sponsors, formik.values.sponsorId, isEdit]);

    useEffect(() => {
        if (isEdit && formik.values.sponsorId && !isCompleted) {
            fetchSponsorCommitments(formik.values.sponsorId);
        }
    }, [isEdit, isCompleted]);

    const handleCommitmentTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        formik.setFieldValue('commitmentType', e.target.value);
        formik.setFieldValue('subType', '');
    };

    const isFieldDisabled = () => {
        if (isEdit) return isCompleted || formik.isSubmitting || isCommitmentLoading;
        return hasExistingCommitment || isCompleted || formik.isSubmitting || isCommitmentLoading;
    };

    return (
        <div className={pathname.includes('/apps/commitment/new') ? 'card' : ''} style={pathname.includes('/apps/commitment/new') ? { padding: "20px" } : {}}>
            <div className="">
                {showToast && (
                    <div className={`fixed top-4 right-4 p-4 rounded-md shadow-lg z-50 ${toastType === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`}>
                        {toastMessage}
                    </div>
                )}

                {hasExistingCommitment && !isCompleted && !isEdit && (
                    <div className="alert alert-warning d-flex align-items-center mb-5" role="alert">
                        <i className="bi bi-exclamation-triangle-fill me-2 fs-4"></i>
                        <div><strong>This sponsor already has an active commitment.</strong></div>
                    </div>
                )}

                {isCompleted && (
                    <div className="alert alert-info d-flex align-items-center mb-5" role="alert">
                        <i className="bi bi-info-circle-fill me-2 fs-4"></i>
                        <div><strong>This commitment is completed and cannot be edited.</strong></div>
                    </div>
                )}

                <form onSubmit={formik.handleSubmit} noValidate>
                    <div className="space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                            {/* Hidden in edit mode */}
                            {!isEdit && (
                                <div className="fv-row mb-7">
                                    <label className="required fw-bold fs-6 mb-2">Select Country</label>
                                    <select
                                        {...formik.getFieldProps('franchiseId')}
                                        style={{
                                            backgroundColor: (hasExistingCommitment || isCompleted) ? '#e9ecef' : '#ffffff',
                                            border: '1px solid #dddddd',
                                            color: '#000000',
                                        }}
                                        className="form-control form-control-solid mb-3 mb-lg-0"
                                        disabled={loadingFranchises || formik.isSubmitting || isCommitmentLoading || isCompleted}
                                    >
                                        <option value="">{loadingFranchises ? 'Loading...' : 'Select Country'}</option>
                                        {franchises.map((franchise) => (
                                            <option key={franchise.id} value={franchise.id}>
                                                {franchise.companyDetails?.name || franchise.personalDetails?.name || 'Unknown Supply chain'}
                                            </option>
                                        ))}
                                    </select>
                                    {formik.touched.franchiseId && formik.errors.franchiseId && (
                                        <div className="fv-plugins-message-container">
                                            <div className="fv-help-block">
                                                <span role="alert">{formik.errors.franchiseId as string}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="fv-row mb-7">
                                <label className="required fw-bold fs-6 mb-2">Select Sponsor</label>
                                <div className="position-relative">
                                    <select
                                        {...formik.getFieldProps('sponsorId')}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            const selectedSponsor = sponsors.find((s: Sponsor) => s.id === e.target.value);
                                            formik.setFieldValue('sponsorName', selectedSponsor?.companyDetails?.name || selectedSponsor?.personalDetails?.name || '');
                                            if (e.target.value && !isCompleted) {
                                                fetchSponsorCommitments(e.target.value);
                                            } else {
                                                setSponsorCommitments([]);
                                                setHasExistingCommitment(false);
                                                if (!isEdit) {
                                                    formik.setFieldValue('commitmentType', '');
                                                    formik.setFieldValue('startDate', '');
                                                    formik.setFieldValue('endDate', '');
                                                }
                                            }
                                        }}
                                        style={{
                                            backgroundColor: isCompleted ? '#e9ecef' : '#ffffff',
                                            border: '1px solid #dddddd',
                                            color: '#000000',
                                            paddingLeft: (formik.values.sponsorId && user?.sponsorLogo) ? '45px' : '12px'
                                        }}
                                        className="form-control form-control-solid mb-3 mb-lg-0"
                                        // ✅ Fixed: removed hasExistingCommitment — user can always change sponsor in add mode
                                        disabled={loadingSponsors || formik.isSubmitting || isCommitmentLoading || isCompleted || isEdit}
                                    >
                                        <option value="">{loadingSponsors ? 'Loading...' : 'Select Sponsor'}</option>
                                        {sponsors.map((sponsor: Sponsor) => (
                                            <option key={sponsor.id} value={sponsor.id}>
                                                {sponsor.companyDetails?.name || sponsor.personalDetails?.name || 'Unknown Sponsor'}
                                            </option>
                                        ))}
                                    </select>
                                    {formik.values.sponsorId && user?.sponsorLogo && (
                                        <img
                                            src={user.sponsorLogo}
                                            alt="sponsor logo"
                                            className="position-absolute rounded-circle"
                                            style={{ width: '20px', height: '20px', left: '12px', top: '50%', transform: 'translateY(-50%)', objectFit: 'cover', pointerEvents: 'none' }}
                                            onError={(e) => { e.currentTarget.style.display = 'none'; }}
                                        />
                                    )}
                                </div>
                                {formik.touched.sponsorId && formik.errors.sponsorId && (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            <span role="alert">{formik.errors.sponsorId as string}</span>
                                        </div>
                                    </div>
                                )}
                                {loadingCommitments && !isCompleted && (
                                    <div className="text-dark mt-1">
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Checking existing commitments...
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="fv-row mb-7">
                                <label className="required fw-bold fs-6 mb-2">Select Package</label>
                                <select
                                    style={{
                                        backgroundColor: isFieldDisabled() ? '#e9ecef' : '#ffffff',
                                        border: '1px solid #dddddd',
                                        color: formik.values.commitmentType ? '#000000' : '#9da4ba'
                                    }}
                                    className="form-control form-control-solid mb-3 mb-lg-0"
                                    {...formik.getFieldProps('commitmentType')}
                                    onChange={handleCommitmentTypeChange}
                                    disabled={isFieldDisabled() || isEdit}
                                >
                                    <option value="" style={{ color: '#9da4ba' }}>Select Package...</option>
                                    {sponsorshipPackages?.map((pkg: any) => (
                                        <option key={pkg.value} value={pkg.value} style={{ color: '#000000' }}>
                                            {pkg.label || pkg.packageName || 'Package'}
                                        </option>
                                    ))}
                                </select>
                                {formik.touched.commitmentType && formik.errors.commitmentType && (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            <span role="alert">{formik.errors.commitmentType as string}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            {formik.values.commitmentType === 'VOLUME_LINKED' && (
                                <div className="fv-row mb-7">
                                    <label className="required fw-bold fs-6 mb-2">Quantity</label>
                                    <input
                                        type="number"
                                        placeholder="Enter Plastic prevention in kg"
                                        step="0.1"
                                        {...formik.getFieldProps('quantity')}
                                        style={{ backgroundColor: isFieldDisabled() ? '#e9ecef' : '#ffffff', border: '1px solid #dddddd', color: '#000000' }}
                                        className="form-control form-control-solid mb-3 mb-lg-0"
                                        autoComplete="off"
                                        disabled={isFieldDisabled()}
                                    />
                                </div>
                            )}

                            {formik.values.commitmentType === 'USER_TYPE_LINKED' && (
                                <div className="fv-row mb-7">
                                    <label className="required fw-bold fs-6 mb-2">Household Number Target</label>
                                    <input
                                        type="number"
                                        placeholder="Enter household target"
                                        step="1"
                                        {...formik.getFieldProps('householdTarget')}
                                        style={{ backgroundColor: isFieldDisabled() ? '#e9ecef' : '#ffffff', border: '1px solid #dddddd', color: '#000000' }}
                                        className="form-control form-control-solid mb-3 mb-lg-0"
                                        autoComplete="off"
                                        disabled={isFieldDisabled()}
                                    />
                                </div>
                            )}

                            {formik.values.commitmentType === 'GENERAL' && (
                                <div className="fv-row mb-7">
                                    <label className="required fw-bold fs-6 mb-2">Project Target</label>
                                    <input
                                        type="number"
                                        placeholder="Enter project target"
                                        step="1"
                                        {...formik.getFieldProps('projectTarget')}
                                        style={{ backgroundColor: isFieldDisabled() ? '#e9ecef' : '#ffffff', border: '1px solid #dddddd', color: '#000000' }}
                                        className="form-control form-control-solid mb-3 mb-lg-0"
                                        autoComplete="off"
                                        disabled={isFieldDisabled()}
                                    />
                                </div>
                            )}
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div className="fv-row mb-7">
                                <label className="required fw-bold fs-6 mb-2">Start date</label>
                                <input
                                    type="date"
                                    {...formik.getFieldProps('startDate')}
                                    style={{ backgroundColor: isFieldDisabled() ? '#e9ecef' : '#ffffff', border: '1px solid #dddddd', color: '#000000' }}
                                    className="form-control form-control-solid mb-3 mb-lg-0"
                                    autoComplete="off"
                                    disabled={isFieldDisabled()}
                                />
                                {formik.touched.startDate && formik.errors.startDate && (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            <span role="alert">{formik.errors.startDate as string}</span>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="fv-row mb-7">
                                <label className="required fw-bold fs-6 mb-2">End date</label>
                                <input
                                    type="date"
                                    {...formik.getFieldProps('endDate')}
                                    style={{ backgroundColor: isFieldDisabled() ? '#e9ecef' : '#ffffff', border: '1px solid #dddddd', color: '#000000' }}
                                    className="form-control form-control-solid mb-3 mb-lg-0"
                                    autoComplete="off"
                                    disabled={isFieldDisabled()}
                                />
                                {formik.touched.endDate && formik.errors.endDate && (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            <span role="alert">{formik.errors.endDate as string}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="text-center pt-15">
                            <button
                                type="submit"
                                style={{
                                    backgroundColor: isCompleted ? '#6c757d' : '#000000',
                                    cursor: isCompleted ? 'not-allowed' : 'pointer'
                                }}
                                className="btn btn-primary"
                                disabled={isCommitmentLoading || formik.isSubmitting || !formik.isValid || isCompleted || (!isEdit && hasExistingCommitment)}
                            >
                                <span className="indicator-label">
                                    {isCompleted ? 'Commitment Completed - Cannot Edit' :
                                        (!isEdit && hasExistingCommitment) ? 'Commitment Already Exists' :
                                            (isEdit ? 'Update' : 'Submit')}
                                </span>
                                {(formik.isSubmitting || isCommitmentLoading) && (
                                    <span className="indicator-progress">
                                        Please wait...{' '}
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CommitmentForm1;